<main id="main" class="main">
  <section class="section dashboard">

    <div class="row" *ngIf="displayCommonPlans">
      <app-common-plans 
        #commonPlans 
        [viewPlan]="false" 
        [isCorporate]="true" 
        [bulkPlansData]="balkPlans"
        [plansData]="plansBlock1" 
        [paidByCompany]="[]" 
        [coveredByCompany]=" []" 
        [paidByEmployee]=" []"
        [bulkplans]="[]" 
        [mode]="'edit'"
        [multiSelectProviancenames]="multiSelectProviancenames" 
        (submitTriggered)="plansSumitInfo()"
        [addWalletForm]="addWalletForm" 
        [addTierForm]="addTierForm" 
        [clientregform]="clientregform"
        [crateTierid]="crateTierid"></app-common-plans>
  <div class="linescrollbar form-container" *ngIf="false">
    <div class="row pb-2">
      <div class="col-12 col-md-12">
        <div class="form-group">

          <h6 class="admintitle">{{lang.Corporate_Level_Group_Plans}}
            &nbsp;&nbsp;<i class="bi bi-info-circle"></i>
          </h6>
        </div>
      </div>
    </div>
    <!-- Block1 With No Tier -->
    <!-- bulk plans -->
    <div class="row">
      <div class="packageWrapper block3packagewrapper plansscreenbulk" *ngFor="let package of balkPlans; let i = index">
        <div class="planheadingwrap" style="padding-left: 0px;">
          <!-- && package && package?.id !== 2 -->
          <!-- <div class=" planheadingwrap" *ngIf="package"></div> -->
          <div class="d-flex position-relative">
            <h6 *ngIf="package?.groups?.length >= 1" class="planheading panel-title ps-3"
              [attr.data-bs-target]="'#collapsethreeBulk' + package?.id" data-bs-toggle="collapse" aria-expanded="true"
              aria-controls="collapsethreeBulk{{ package?.id }}">
              {{ package?.name }}
            </h6>
            <!-- <h6 class="planheading" *ngIf="package?.groups?.length >  1">
                      <h6 class="planheading" *ngIf="package?.groups?.length >  1">
                        {{ package?.name }}
                      </h6> -->
            <div class="position-absolute" style="top: 18px;left: 10px;bottom: -39px;">
              <div *ngIf="role==='ADMINISTRATOR' && package?.groups?.length >= 1"
                title="{{getTextForTooltip1(package?.published,package?.restrictedAccess)}}"
                [ngStyle]=" {'border-color' : getColorForPlans1(package?.published,package?.restrictedAccess) }"
                class="outer my-auto col-2" data-bs-toggle="">
                <span class="inner"
                  [ngStyle]="{ 'background': getColorForPlans1(package?.published,package?.restrictedAccess) }"></span>
              </div>
            </div>

          </div>

        </div>

        <div class="form-group package" style="margin-top:-2px">
          <!-- &&package && package?.id !== 2 -->
          <div class="package-groups1" *ngFor="let group of package?.groups; let j = index" title="">
            <div class="price" *ngIf="group && group != null">
              <div class="header overflow-ellipsis1 panel-title" [attr.data-bs-target]="'#collapsethreeBulk' + group.id"
                data-bs-toggle="collapse" aria-expanded="true" aria-controls="collapsethreeBulk{{ group.id }}"
                title="{{ group.name }}" *ngIf="
                  group &&
                  group.subGroups &&
                  group.subGroups.length > 0 &&
                  package?.groups?.length >  1
                ">
                {{ group.name }}
              </div>
            </div>
            <div class="planbody" *ngIf="
              group && group.subGroups && group.subGroups.length > 0
            ">
              <div *ngFor="let subgroup of group.subGroups; let k = index">
                <div *ngIf="subgroup" id="collapsethreeBulk{{
                  package?.groups?.length >  1
                    ? subgroup.parentId
                    : package?.id
                }}" class="accordion-collapse collapse show">
                  <div style="display: flex;" class="position-relative">
                    <div class="featuutrebody1 row justify-content-center align-items-center" [style.background-color]="
                      subgroup.backgroundColor
                        ? subgroup.backgroundColor
                        : defaultColor
                    " *ngIf="subgroup">
                      <div class="col-1">
                        <div *ngIf="role==='ADMINISTRATOR' && package?.groups?.length >= 1"
                          title="{{getTextForTooltip(subgroup.published?.data[0],subgroup.restricted)}}"
                          [ngStyle]=" {'border-color' : getColorForPlans(subgroup.published?.data[0],subgroup.restricted) }"
                          class="outer my-auto col-2" data-bs-toggle="">
                          <span class="inner"
                            [ngStyle]="{ 'background': getColorForPlans(subgroup.published?.data[0],subgroup.restricted,subgroup.name) }"></span>
                        </div>
                      </div>
                      <span class="col-10">{{ subgroup.name }}</span>

                      <input type="checkbox" id="plancheckboxbulk{{ subgroup.id }}" class=" col-1 plancheckboxbulk{{
                        package?.id
                      }} plancv largerCheckbox" attr.data="{{ package?.allowMultiple }}##{{
                        subgroup.disallowedPlanLevels
                      }}##{{ package?.id }}##{{ subgroup.parentId }}##{{
                        subgroup.id
                      }}##{{ package?.name }}##{{ subgroup.name }}##{{
                        subgroup
                      }}##{{ subgroup.ordering }}" (change)="
                      onCheckboxChangeBulkPlns(
                          $event,
                          package?.allowMultiple,
                          subgroup.disallowedPlanLevels,
                          package?.id,
                          subgroup?.id,
                          package?.name,
                          subgroup.name,
                          subgroup,
                          subgroup.ordering,
                          group.id,
                          group.name,
                          i,
                          j,
                          k
                        )
                      " />


                    </div>

                    <!-- <div>{{checkboxCheck[subgroup.id]}}{{subgroup.id}}</div> -->
                    <div id="checkbox-{{subgroup.id}}" *ngIf="checkboxCheck[subgroup.id]==true"
                    class="countblock">&nbsp;

                    <label for="Corporation" class="Corporation">Head Count:</label>

                    <input type="number" class="headcountbox" [(ngModel)]="showHeadCount[subgroup.id]"
                      class="headerCount" (keypress)="preventNegative($event)"
                      (input)="preventNonNumeric($event)"
                      (change)="updateTotal(j,$event,subgroup,subgroup.settings?.requiredCustomersCount)">&nbsp;
                    <label for="Corporation" class="Corporation"
                      *ngIf="!showHeadCount[subgroup.id] || showHeadCount[subgroup.id] <=0"
                      style="color:red">
                      {{lang.Please_enter_head_count_for}}</label>
                    &nbsp;

                    <span class="text-left"
                      *ngIf="checkboxCheck[subgroup.id] && showinputboxvalue[subgroup.id] && (showHeadCount[subgroup.id] || showHeadCount[subgroup.id] >0)">
                      <label for="DownloadButton" id="uploadButtonExcel" title="Download Template"
                        data-taggle="tooltip"
                        (click)="exportAsXLSX(subgroup.id,subgroup.settings.memberDetailsKeysDB)"
                        class="Cursorpointer">
                        <img src="../../../assets/img/download-template.png" style="width:100px;height:30px">
                      </label>&nbsp;
                      <label for="uploadButton-{{subgroup.id}}" id="uploadButtonExcel-{{subgroup.id}}"
                        title="Upload Employee/Entity List" data-taggle="tooltip" class="Cursorpointer">
                        <img src="../../../assets/img/upload-employee-list.png"
                          style="width:100px;height:30px">
                        <input id="uploadButton-{{subgroup.id}}" #myFileInput style="display: none"
                          type="file"
                          (input)="onFileChangeExcel($event,subgroup.id,subgroup.settings.memberDetailsKeysDB)" />
                      </label> &nbsp;
                      <i class="fa fa-eye" title="view" aria-hidden="true" data-bs-toggle="modal"
                        (click)="editEmployees(subgroup.id)"></i>

                    </span>
                  </div>

                  <!-- new process of updating bulk plan head count -->
                    <!-- <div id="checkbox-{{subgroup.id}}" *ngIf="checkboxCheck[subgroup.id]==true && !isPlanInBulkplans(subgroup.id)" class="countblock">&nbsp;

                      <label for="Corporation" class="Corporation">Head Count:</label>

                      <input type="number" class="headcountbox" [(ngModel)]="showHeadCount[subgroup.id]"
                        class="headerCount" (keypress)="preventNegative($event)" (input)="preventNonNumeric($event)"
                        (change)="updateTotal(j,$event,subgroup,subgroup.settings?.requiredCustomersCount)">&nbsp;
                      <label for="Corporation" class="Corporation"
                        *ngIf="!showHeadCount[subgroup.id] || showHeadCount[subgroup.id] <=0" style="color:red">
                        {{lang.Please_enter_head_count_for}} {{subgroup.name}}</label>
                      &nbsp;

                      <span class="text-left"
                        *ngIf="checkboxCheck[subgroup.id] && showinputboxvalue[subgroup.id] && (showHeadCount[subgroup.id] || showHeadCount[subgroup.id] >0)">
                        <label for="DownloadButton" id="uploadButtonExcel" title="Download Template" data-taggle="tooltip"
                          (click)="exportAsXLSX(subgroup.id,subgroup.settings.memberDetailsKeysDB)" class="Cursorpointer">
                          <img src="../../../assets/img/download-template.png" style="width:100px;height:30px">
                        </label>&nbsp;
                        <label for="uploadButton-{{subgroup.id}}" id="uploadButtonExcel-{{subgroup.id}}"
                          title="Upload Employee/Entity List" data-taggle="tooltip" class="Cursorpointer">
                          <img src="../../../assets/img/upload-employee-list.png" style="width:100px;height:30px">
                          <input id="uploadButton-{{subgroup.id}}" #myFileInput style="display: none" type="file"
                            (input)="onFileChangeExcel($event,subgroup.id,subgroup.settings.memberDetailsKeysDB)" />
                        </label> &nbsp;
                        <i class="fa fa-eye" title="view" aria-hidden="true" data-bs-toggle="modal"
                          (click)="editEmployees(subgroup.id,'edit')"></i>

                      </span>
                    </div>
                    
                    <div *ngIf="isPlanInBulkplans(subgroup.id)" class='mx-2'>
                      <div id="checkbox-{{subgroup.id}}" *ngIf="checkboxCheck[subgroup.id] == true" class="countblock">
                        <div *ngFor="let plan of getPlansByPlanLevel(subgroup.id), let index = i" class="d-flex align-items-center">
                          <label for="Corporation" class="Corporation">Head Count:</label>
                          <label>{{ plan.quantity }}</label>&nbsp;
                          <label *ngIf="plan.terminationDate" class="d-flex align-items-center">
                            | Termination Date : {{plan.terminationDate?.slice(0,10)}}&nbsp;
                              <i 
                                style="color:rgb(56, 76, 159)" 
                                class="bi bi-pencil-fill"
                                data-bs-target="#edit-headcount"
                                data-bs-toggle="modal"
                                (click)="updateBulkHeadCount(plan)"
                                ></i>&nbsp;&nbsp;
                                <i 
                                style="color:red" 
                                class="bi bi-x-lg"
                                data-bs-target="#terminate-bulkplan"
                                data-bs-toggle="modal"
                                (click)="terminateBulkPlan(plan)"
                              ></i>
                          </label>
                          <label *ngIf="!plan.terminationDate">| Activation Date : {{plan.activationDate?.slice(0,10)}}&nbsp;
                              <i 
                                style="color:rgb(56, 76, 159)" 
                                class="bi bi-pencil-fill"
                                data-bs-target="#edit-headcount"
                                data-bs-toggle="modal"
                                (click)="updateBulkHeadCount(plan,i)"
                                ></i>&nbsp;&nbsp;
                                <i 
                                style="color:red" 
                                class="bi bi-x-lg"
                                data-bs-target="#terminate-bulkplan"
                                data-bs-toggle="modal"
                                (click)="terminateBulkPlan(plan,i)"
                              ></i>
                          </label>
                        </div>
                      </div>
                    </div> -->
                    

                    <!-- <div class="countblock" *ngIf="package?.id==2">&nbsp;
                                <label for="Corporation" class="Corporation" *ngIf="showinputbox==k">Head Count:</label>

                                <input type="text" class="headcountbox" *ngIf="showinputbox==k"
                                  [(ngModel)]="showEmployeeValue" class="headerCount"
                                  (change)="updateTotal(j,$event)">&nbsp;
                                <label for="Corporation" class="Corporation" *ngIf="showinputbox==k && headCountmiss"
                                  style="color:red">Please enter
                                  head count</label>
                                &nbsp;

                                <span class="text-left"
                                  *ngIf="subgroup.name=='Complete Wellness' && showinputboxvalue==20 && showEmployeeValue">
                                  <label for="DownloadButton" id="uploadButtonExcel" title="Download Template"
                                    data-taggle="tooltip" (click)="exportAsXLSX()" class="Cursorpointer">
                                    <img src="../../../assets/img/download-template.png" style="width:100px;height:30px">
                                  </label>&nbsp;
                                  <label for="uploadButton" id="uploadButtonExcel" title="Upload Employee/Entity List"
                                    data-taggle="tooltip" class="Cursorpointer">
                                    <img src="../../../assets/img/upload-employee-list.png"
                                      style="width:100px;height:30px">
                                    <input id="uploadButton" #myFileInput style="display: none" type="file"
                                      (input)="onFileChangeExcel($event)" />
                                  </label> &nbsp;
                                  <i class="fa fa-eye" title="view" aria-hidden="true" data-bs-toggle="modal"
                                    data-bs-target="#showBulkEmployeelist"></i>
                                </span>
                              </div>

                              <div class="countblock" *ngIf="package?.id==11">&nbsp;
                                <label for="Corporation" class="Corporation" *ngIf="showinputbox1==k">Head Count:</label>

                                <input type="text" class="headcountbox" *ngIf="showinputbox1==k"
                                  [(ngModel)]="showEmployeeValue1" class="headerCount"
                                  (change)="updateTotal1(j,$event)">&nbsp;
                                <label for="Corporation" class="Corporation" *ngIf="showinputbox1==k && headCountmiss1"
                                  style="color:red">Please enter
                                  head count</label>
                                &nbsp;

                                <span class="text-left"
                                  *ngIf="subgroup.name=='Personal Protection' && showinputboxvalue1==34 && showEmployeeValue1">
                                  <label for="DownloadButton" id="uploadButtonExcel" title="Download Template"
                                    data-taggle="tooltip" (click)="exportAsXLSXWaddel()" class="Cursorpointer">
                                    <img src="../../../assets/img/download-template.png" style="width:100px;height:30px">
                                  </label>&nbsp;
                                  <label for="uploadButtonwaddell" id="uploadButtonExcelwaddell"
                                    title="Upload Employee/Entity List" data-taggle="tooltip" class="Cursorpointer">
                                    <img src="../../../assets/img/upload-employee-list.png"
                                      style="width:100px;height:30px">
                                    <input id="uploadButtonwaddell" #myFileInputwaddel style="display: none" type="file"
                                      (input)="onFileChangeExcelWaddel($event)" />
                                  </label> &nbsp;
                                  <i class="fa fa-eye" title="view" aria-hidden="true" data-bs-toggle="modal"
                                    data-bs-target="#showBulkEmployeelistwaddell"></i>
                                </span>
                              </div> -->
                  </div>
                </div>


                <!-- <textarea type="text" class="tierconfig"> Employee</textarea> -->
              </div>

            </div>

          </div>
        </div>

      </div>

    </div>

    <div class="row">
      <div class="col-12 col-md-12">
        <div class="form-group">
          <span class="coreplans" *ngIf="showtierbasicplans">{{lang.Template}}
            <select (change)="coreplantemplate($event)" [(ngModel)]="coreplantemplateValue">
              <option [value]="null">{{lang.Select}}</option>
              <option value="starter">{{lang.Starter}}</option>
              <option value="standard">{{lang.Standard}}</option>
              <option value="executive">{{lang.Executive}}</option>
              <option value="custom">{{lang.Custom}}</option>
            </select>
          </span>
          <h6 class="admintitle">
            {{lang.Core_Plans_Premium_paid_100_by_employer}}.&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
          </h6>
        </div>
      </div>
    </div>


    <!-- Block1 With No Tier -->
    <div class="row" *ngIf="showtierbasicplans">
      <div class="col-12 col-md-12 pb-2">
        <span class="enabledplans1">
          <!-- Enabled?<input class="" type="radio" name="upgradeplans" id="upgradeplanstrue" #upgradeplanstrue value="true"
                    (click)="upgradeplans($event)" />
                  <label class="form-check-label" for="workinghoursno" class="upgradeplans">&nbsp;Yes</label>&nbsp;&nbsp;
                  <input class="" type="radio" name="upgradeplans" id="upgradeplansfalse" #upgradeplansfalse value="false"
                    (click)="upgradeplans($event)" checked />
                  <label class="form-check-label" for="workinghoursno" class="upgradeplans">&nbsp;No</label>
                 -->
        </span>

        <!-- <h6 class="admintitle">
                  Core Plans (Premium paid 100% by employer).&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
                </h6> -->
      </div>

      <div class="packageWrapper plansscreen" *ngFor="let package of plansBlock1; let i = index">
        <div class="planheadingwrap" style="padding-left: 6px;">
          <!-- *ngIf="!(package?.id == hidementalplans || package?.id == hidewaddellplans)" -->
          <div class="d-flex position-relative">
            <h6 *ngIf="package?.groups?.length >= 1 && showPackageName(package?.groups,'core')" class="planheading ps-3"
              id="plancheckcollapseone{{ package?.id }}" aria-expanded="true" aria-controls="collapseone{{ package?.id }}"
              [attr.data-bs-target]="'#collapseone' + package?.id" data-bs-toggle="collapse"
              style="justify-content: space-around;" (click)="toggleCollapsee(package?.id)" id="parent1">
              {{ package?.name }}<span>{{ isCollapsed[package?.id] ? '+' : '-' }}</span>
            </h6>
            <!-- <h6 class="planheading" *ngIf="package?.groups?.length >  1">
                        {{ package?.name }}
                      </h6> -->
            <div class="position-absolute" style="top: 18px;left: 10px;bottom: -39px;">
              <div
                *ngIf="role==='ADMINISTRATOR' && package?.groups?.length >= 1 && showPackageName(package?.groups,'core')"
                title="{{getTextForTooltip1(package?.published,package?.restrictedAccess)}}"
                [ngStyle]=" {'border-color' : getColorForPlans1(package?.published,package?.restrictedAccess) }"
                class="outer my-auto col-2" data-bs-toggle="">
                <span class="inner"
                  [ngStyle]="{ 'background': getColorForPlans1(package?.published,package?.restrictedAccess) }"></span>
              </div>
            </div>
            <div class="form-group package" *ngIf="!isCollapsed[package?.id]">
              <!-- *ngIf="!(package?.id == hidementalplans || package?.id == hidewaddellplans)" -->
              <div class="package-groups1" *ngFor="let group of package?.groups; let j = index" title="">
                <div class="price" id="myGroup">
                  <div *ngIf="package?.groups?.length >  1 && showPackageName(package?.groups,'core')"
                    class="header overflow-ellipsis1 panel-title" [style.background-color]="
                                group.backgroundColor
                                  ? group.backgroundColor
                                  : defaultColor
                              " id="plancheckcollapseone{{ group.id }}" [attr.data-bs-target]="'#collapseone' + group.id"
                    data-bs-toggle="collapse" aria-expanded="true" aria-controls="collapseone{{ group.id }}"
                    title="{{ group.name }}">
                    {{ group.name }}
                  </div>
                </div>
                <div class="planbody" *ngIf="group.subGroups && group.subGroups.length > 0 ">
                  <div *ngFor="let subgroup of group.subGroups; let k = index">
                    <!-- <div>collapseone{{
                                package?.groups?.length > 1
                                ? subgroup.parentId
                                : package?.id
                                }}{{package?.groups.length}}</div> -->
                    <div *ngIf="subgroup && subgroup?.settings?.core" id="collapseone{{
                                  package?.groups?.length >  1
                                    ? subgroup.parentId
                                    : package?.id
                                }}" class="accordion-collapse collapse show">
                      <div class="featuutrebody" [style.background-color]="
                                    subgroup.backgroundColor
                                      ? subgroup.backgroundColor
                                      : defaultColor
                                  ">
                        <!-- <span>&#x2713; {{ subgroup.name }}</span> -->
                        <div class="row justify-content-center align-items-center">
                          <div class="col-1">
                            <div *ngIf="role==='ADMINISTRATOR' && package?.groups?.length >= 1"
                              title="{{getTextForTooltip(subgroup.published?.data[0],subgroup.restricted)}}"
                              [ngStyle]=" {'border-color' : getColorForPlans(subgroup.published?.data[0],subgroup.restricted) }"
                              class="outer my-auto col-2" data-bs-toggle="">
                              <span class="inner"
                                [ngStyle]="{ 'background': getColorForPlans(subgroup.published?.data[0],subgroup.restricted,subgroup.name) }"></span>
                            </div>
                          </div>
                          <span class="col-9"> {{ subgroup.name }}</span>
                          <input type="checkbox" [checked]="subgroup.checked" id="plancheck{{ subgroup.id }}" class="col-1 plancheckbox{{
                                        package?.id
                                      }} plancv largerCheckbox block1" attr.data="{{ package?.allowMultiple }}##{{
                                        subgroup.disallowedPlanLevels
                                      }}##{{ package?.id }}##{{
                                        subgroup.parentId
                                      }}##{{ subgroup.id }}##{{ package?.name }}##{{
                                        subgroup.namego
                                      }}##{{ subgroup }}##{{ subgroup.ordering }}##{{
                                        i
                                      }}##{{ j }}##{{ k }}" (change)="
                                        onCheckboxChange1(
                                          $event,
                                          package?.allowMultiple,
                                          subgroup.disallowedPlanLevels,
                                          package?.id,
                                          subgroup.id,
                                          package?.name,
                                          subgroup.name,
                                          subgroup,
                                          subgroup.ordering,
                                          group.id,
                                          group.name,
                                          i,
                                          j,
                                          k
                                        )
                                      " />
                        </div>
                        <!-- <div class="executiveplansselection" *ngIf="subgroup.coverage=='Exec'"> -->

                        <div class="executiveplansselection"
                          *ngIf="subgroup.id == '17' || subgroup.id == '18' || subgroup.id == '28'">
                          <label class="radio-inline executiveplans">
                            <input type="checkbox" name="executiveplans{{ subgroup.id }}"
                              id="executiveplanssingle{{ subgroup.id }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverage(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                            {{lang.Single}}
                          </label>
                          <label class="radio-inline executiveplans">
                            <input type="checkbox" name="executiveplans{{ subgroup.id }}"
                              id="executiveplanscouple{{ subgroup.id }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverage(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                            {{lang.Couple}}
                          </label>
                          <label class="radio-inline executiveplans">
                            <input type="checkbox" name="executiveplans{{ subgroup.id }}"
                              id="executiveplansfamily{{ subgroup.id }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverage(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                            {{lang.Family}}
                          </label>
                        </div>


                      </div>
                      <ng-container *ngIf="role==='ADMINISTRATOR'">
                        <div class="planCoverage" *ngIf="subgroup.checked && plansCoveragecheckboxCheck[subgroup.id]">
                          <!-- <ul class="tiersConfigul">
                                      <li>Configure Tier</li>
                                    </ul> -->
                          <div class="d-flex align-items-center">
                            <select class="form-control" id="Province" placeholder="Province"
                              [(ngModel)]="getPlanCoverage[subgroup.id]">
                              <option value="" [disabled]="true" selected>{{lang.Select}}</option>
                              <option *ngFor="let coverage of companyPaidCoveragePlanLevels[subgroup.id]"
                                [value]="coverage.value">
                                {{ coverage.label }}&nbsp;<i class="fa fa-info-circle" aria-hidden="true"
                                  title="{{coverage.description}}"></i>
                              </option>
                            </select>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>

      <div class="row">
        <div class="offset-md-10 col-md-2">
          <button class="btn btn-primary" type="button" data-bs-toggle="modal" data-bs-target="#tierConfigure"
            *ngIf="showtieradvplans" style="float: right" (click)="configuretiers()">
            Configure&nbsp;&nbsp;<i aria-hidden="true" class="fa fa-long-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Block2 With No Tier -->
    <div class="row" *ngIf="showtierbasicplans">
      <div class="row header-title  m-2">
        <div class=" my-auto col-6">
          {{lang.Upgrade_Plans_Premium_difference_paid_by_employee_through_payroll_deduction}}.&nbsp;&nbsp;<i
            class="bi bi-info-circle"></i>
        </div>
        <div class="my-auto col-4">{{lang.Enabled}}
          <input class="" type="radio" name="upgradeplans" id="upgradeplanstrue" #upgradeplanstrue value="true"
            (click)="upgradeplans($event)" />
          <label class="form-check-label" for="workinghoursno" class="upgradeplans">&nbsp;{{lang.Yes}}</label>&nbsp;&nbsp;
          <input class="" type="radio" name="upgradeplans" id="upgradeplansfalse" #upgradeplansfalse value="false"
            (click)="upgradeplans($event)" checked />
          <label class="form-check-label" for="workinghoursno" class="upgradeplans">&nbsp;{{lang.No}}</label>
        </div>

      </div>
      <!-- <div class="col-12 col-md-12 pb-2">
                  <span class="enabledplans1">Enabled?
                    <input class="" type="radio" name="upgradeplans" id="upgradeplanstrue" #upgradeplanstrue value="true"
                      (click)="upgradeplans($event)" />
                    <label class="form-check-label" for="workinghoursno"
                      class="upgradeplans">&nbsp;Yes</label>&nbsp;&nbsp;
                    <input class="" type="radio" name="upgradeplans" id="upgradeplansfalse" #upgradeplansfalse
                      value="false" (click)="upgradeplans($event)" checked />
                    <label class="form-check-label" for="workinghoursno" class="upgradeplans">&nbsp;No</label>
                  </span>

                  <h6 class="admintitle">
                    Upgrade Plans (Premium difference paid by employee through
                    payroll deduction).&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
                  </h6>
                </div> -->
      <div class="row" *ngIf="upgradeplansselection">
        <div class="packageWrapper block2packagewrapper plansscreen2"
          *ngFor="let package of plansresblack2; let i = index">
          <div class="planheadingwrap" style="padding-left: 6px;">
            <!-- *ngIf="package && package?.id !== 3 && package?.id !== hidewaddellplans" -->
            <div class="d-flex position-relative">
              <h6 *ngIf="package?.groups?.length >= 1 && showPackageName(package?.groups,'upgrade')" class="planheading"
                [attr.data-bs-target]="'#collapsetwo' + package?.id" data-bs-toggle="collapse" aria-expanded="true"
                aria-controls="collapsetwo{{ package?.id }}" style="justify-content: space-around;"
                (click)="toggleCollapseeTwo(package?.id)" id="parent2">
                {{ package?.name }}<span>{{ isCollapsedTwo[package?.id] ? '+' : '-' }}</span>
              </h6>
              <!-- <h6 class="planheading" *ngIf="package?.groups?.length >  1">
                          {{ package?.name }}
                        </h6> -->
              <div class="position-absolute" style="top: 18px;left: 10px;bottom: -39px;">
                <div
                  *ngIf="role==='ADMINISTRATOR' && package?.groups?.length >= 1 && showPackageName(package?.groups,'upgrade')"
                  title="{{getTextForTooltip1(package?.published,package?.restrictedAccess)}}"
                  [ngStyle]=" {'border-color' : getColorForPlans1(package?.published,package?.restrictedAccess) }"
                  class="outer my-auto col-2" data-bs-toggle="">
                  <span class="inner"
                    [ngStyle]="{ 'background': getColorForPlans1(package?.published,package?.restrictedAccess) }"></span>
                </div>
              </div>
              <div class="form-group package" *ngIf="!isCollapsedTwo[package?.id]">
                <!-- *ngIf="package && package?.id !== 3 && package?.id !== hidewaddellplans" -->
                <div class="package-groups1" *ngFor="let group of package?.groups; let j = index" title="">
                  <div class="price" *ngIf="group && group != null  && showPackageName(package?.groups,'upgrade')">
                    <div class="header overflow-ellipsis1 panel-title" [style.background-color]="
                                  group.backgroundColor
                                    ? group.backgroundColor
                                    : defaultColor
                                " [attr.data-bs-target]="'#collapsetwo' + group.id" data-bs-toggle="collapse"
                      aria-expanded="true" aria-controls="collapsetwo{{ group.id }}" title="{{ group.name }}" *ngIf="
                                  group &&
                                  group.subGroups &&
                                  group.subGroups.length > 0 &&
                                  package?.groups?.length >  1
                                ">
                      {{ group.name }}
                    </div>
                  </div>

                  <div class="planbody" *ngIf="
                                group && group.subGroups && group.subGroups.length > 0
                              ">
                    <div *ngFor="
                                  let subgroup of group.subGroups;
                                  let k = index
                                ">
                      <!-- {{subgroup?.settings?.upgrade}} -->

                      <div *ngIf="subgroup && subgroup?.settings?.upgrade" id="collapsetwo{{
                                    package?.groups?.length >  1
                                      ? subgroup.parentId
                                      : package?.id
                                  }}" class="accordion-collapse collapse show">
                        <div class="featuutrebody row justify-content-center align-items-center" [style.background-color]="
                                      subgroup.backgroundColor
                                        ? subgroup.backgroundColor
                                        : defaultColor
                                    " *ngIf="subgroup">
                          <div class="col-2">
                            <div *ngIf="role==='ADMINISTRATOR' && package?.groups?.length >= 1"
                              title="{{getTextForTooltip(subgroup.published?.data[0],subgroup.restricted)}}"
                              [ngStyle]=" {'border-color' : getColorForPlans(subgroup.published?.data[0],subgroup.restricted) }"
                              class="outer my-auto col-2" data-bs-toggle="">
                              <span class="inner"
                                [ngStyle]="{ 'background': getColorForPlans(subgroup.published?.data[0],subgroup.restricted,subgroup.name) }"></span>
                            </div>
                          </div>
                          <span class="col-9">{{ subgroup.name }}</span>
                          <input class="col-1" type="checkbox" id="plancheck2Upgrade{{ subgroup.id }}" class="plancheckbox2{{
                                        package?.id
                                      }} plancheckbox2{{
                                        subgroup.id
                                      }} plancv largerCheckbox block2" attr.data="{{ package?.allowMultiple }}##{{
                                        subgroup.disallowedPlanLevels
                                      }}##{{ package?.id }}##{{
                                        subgroup.parentId
                                      }}##{{ subgroup.id }}##{{ package?.name }}##{{
                                        subgroup.name
                                      }}##{{ subgroup }}##{{ subgroup.ordering }}##{{
                                        i
                                      }}##{{ j }}##{{ k }}" (change)="
                                        onCheckboxChange2(
                                          $event,
                                          package?.allowMultiple,
                                          subgroup.disallowedPlanLevels,
                                          package?.id,
                                          subgroup.id,
                                          package?.name,
                                          subgroup.name,
                                          subgroup,
                                          subgroup.ordering,
                                          group.id,
                                          group.name,
                                          i,
                                          j,
                                          k
                                        )
                                      " />

                          <div class="executiveplansselection" *ngIf="
                                        subgroup.coverage == '' && (subgroup.id == '17' || subgroup.id == '18' || subgroup.id == '28')
                                      ">
                            <label class="radio-inline executiveplans">
                              <input type="checkbox" name="executiveplansblock2{{ subgroup.id }}" id="executiveplansblock2single{{
                                            subgroup.id
                                          }}" style="vertical-align: bottom" (click)="
                                            executiveplansCoverage2(
                                              $event,
                                              i,
                                              j,
                                              k,
                                              subgroup.id
                                            )
                                          " />
                              {{lang.Single}}
                            </label>
                            <label class="radio-inline executiveplans">
                              <input type="checkbox" name="executiveplansblock2{{ subgroup.id }}" id="executiveplansblock2couple{{
                                            subgroup.id
                                          }}" style="vertical-align: bottom" (click)="
                                            executiveplansCoverage2(
                                              $event,
                                              i,
                                              j,
                                              k,
                                              subgroup.id
                                            )
                                          " />
                              {{lang.Couple}}
                            </label>
                            <label class="radio-inline executiveplans">
                              <input type="checkbox" name="executiveplansblock2{{ subgroup.id }}" id="executiveplansblock2family{{
                                            subgroup.id
                                          }}" style="vertical-align: bottom" (click)="
                                            executiveplansCoverage2(
                                              $event,
                                              i,
                                              j,
                                              k,
                                              subgroup.id
                                            )
                                          " />
                              {{lang.Family}}
                            </label>
                          </div>

                          <div class="executiveplansselection" *ngIf="
                                        subgroup.coverage == '001' && (subgroup.id == '17' || subgroup.id == '18' || subgroup.id == '28')
                                      ">
                            <label class="radio-inline executiveplans">
                              <input type="checkbox" name="executiveplansblock2{{ subgroup.id }}" id="executiveplansblock2couple{{
                                            subgroup.id
                                          }}" style="vertical-align: bottom" (click)="
                                            executiveplansCoverage2(
                                              $event,
                                              i,
                                              j,
                                              k,
                                              subgroup.id
                                            )
                                          " />
                              {{lang.Couple}}
                            </label>
                            <label class="radio-inline executiveplans">
                              <input type="checkbox" name="executiveplansblock2{{ subgroup.id }}" id="executiveplansblock2family{{
                                            subgroup.id
                                          }}" style="vertical-align: bottom" (click)="
                                            executiveplansCoverage2(
                                              $event,
                                              i,
                                              j,
                                              k,
                                              subgroup.id
                                            )
                                          " />
                              {{lang.Family}}
                            </label>
                          </div>
                          <div class="executiveplansselection" *ngIf="
                                        subgroup.coverage == '010' && (subgroup.id == '17' || subgroup.id == '18' || subgroup.id == '28')
                                      ">
                            <label class="radio-inline executiveplans">
                              <input type="checkbox" name="executiveplansblock2{{ subgroup.id }}" id="executiveplansblock2family{{
                                            subgroup.id
                                          }}" style="vertical-align: bottom" (click)="
                                            executiveplansCoverage2(
                                              $event,
                                              i,
                                              j,
                                              k,
                                              subgroup.id
                                            )
                                          " />
                              {{lang.Family}}
                            </label>
                          </div>
                          <div class="executiveplansselection" *ngIf="
                                        subgroup.coverage == '011' && (subgroup.id == '17' || subgroup.id == '18' || subgroup.id == '28')
                                      ">
                            <label class="radio-inline executiveplans">
                              <input type="checkbox" name="executiveplansblock2{{ subgroup.id }}" id="executiveplansblock2family{{
                                            subgroup.id
                                          }}" style="vertical-align: bottom" (click)="
                                            executiveplansCoverage2(
                                              $event,
                                              i,
                                              j,
                                              k,
                                              subgroup.id
                                            )
                                          " />
                              {{lang.Family}}
                            </label>
                          </div>
                        </div>
                      </div>
                      <!-- <textarea type="text" class="tierconfig"> Employee</textarea> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="planheadingwrap" *ngIf="package"></div> package && package?.id !== 2 -->
            <!-- <h6 class="planheading">{{ package?.name }}<span *ngIf="package?.groups.length<=1" class="panel-title" [attr.data-bs-target]="'#collapsetwo'+package?.id" data-bs-toggle="collapse"   aria-expanded="true" aria-controls="collapsetwo{{package?.id}}"></span></h6> -->
          </div>

        </div>
      </div>
    </div>
    <!-- Block3 With No Tier -->
    <div class="row mt-2" *ngIf="showtierbasicplans">
      <div class="row header-title  m-2">
        <div class=" my-auto col-6">
          {{lang.Voluntary_Plans_Premium_paid_100_by_employee_directly}}.&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
        </div>
        <div class="my-auto col-4">{{lang.Enabled}}
          <input class="" type="radio" name="employeepurchase" id="employeepurchasetrue" #employeepurchasetrue
            value="true" (click)="planpurchase($event)" />
          <label class="form-check-label" for="employeepurchasetrue"
            class="employeepurchase">&nbsp;{{lang.Yes}}</label>&nbsp;&nbsp;
          <input class="" type="radio" name="employeepurchase" id="employeepurchasefalse" #employeepurchasefalse
            value="false" (click)="planpurchase($event)" checked />
          <label class="form-check-label" for="employeepurchasefalse" class="employeepurchase">&nbsp;{{lang.No}}</label>
        </div>
      </div>


      <div class="row" *ngIf="employeeplanpurchase">
        <div class="packageWrapper block3packagewrapper plansscreen3"
          *ngFor="let package of plansresblack3; let i = index">
          <div class="planheadingwrap" style="padding-left: 6px;">
            <div class="d-flex position-relative">
              <h6 *ngIf="package?.groups?.length >= 1 && showPackageName(package?.groups,'voluntary')" class="planheading"
                [attr.data-bs-target]="'#collapsethree' + package?.id" data-bs-toggle="collapse" aria-expanded="true"
                aria-controls="collapsethree{{ package?.id }}" style="justify-content: space-around;"
                (click)="toggleCollapseeThree(package?.id)" id="parent3">
                {{ package?.name }}<span>{{ isCollapsedThree[package?.id] ? '+' : '-' }}</span>
              </h6>
              <!-- <h6 class="planheading" *ngIf="package?.groups?.length >  1">
                          {{ package?.name }}
                        </h6> -->
              <div class="position-absolute" style="top: 18px;left: 10px;bottom: -39px;">
                <div
                  *ngIf="role==='ADMINISTRATOR' && package?.groups?.length >= 1 && showPackageName(package?.groups,'voluntary')"
                  title="{{getTextForTooltip1(package?.published,package?.restrictedAccess)}}"
                  [ngStyle]=" {'border-color' : getColorForPlans1(package?.published,package?.restrictedAccess) }"
                  class="outer my-auto col-2" data-bs-toggle="">
                  <span class="inner"
                    [ngStyle]="{ 'background': getColorForPlans1(package?.published,package?.restrictedAccess) }"></span>
                </div>
              </div>
              <div class="form-group package" *ngIf="!isCollapsedThree[package?.id]">
                <!-- *ngIf="
                          package &&
                          package?.id !== 1 &&
                          package &&
                          package?.id !== 4 &&
                          package &&
                          package?.id !== 2 && package?.id !== hidewaddellplans" -->
                <!-- &&package && package?.id !== 2 -->
                <div class="package-groups1" *ngFor="let group of package?.groups; let j = index" title="">
                  <div class="price" *ngIf="group && group != null  && showPackageName(package?.groups,'voluntary')">
                    <div class="header overflow-ellipsis1 panel-title" [attr.data-bs-target]="'#collapsethree' + group.id"
                      data-bs-toggle="collapse" aria-expanded="true" aria-controls="collapsethree{{ group.id }}"
                      title="{{ group.name }}" *ngIf="
                                  group &&
                                  group.subGroups &&
                                  group.subGroups.length > 0 &&
                                  package?.groups?.length >  1
                                ">
                      {{ group.name }}
                    </div>
                  </div>
                  <div class="planbody" *ngIf="
                                group && group.subGroups && group.subGroups.length > 0
                              ">
                    <div *ngFor="
                                  let subgroup of group.subGroups;
                                  let k = index
                                ">
                      <div *ngIf="subgroup &&  subgroup?.settings?.voluntary" id="collapsethree{{
                                    package?.groups?.length >  1
                                      ? subgroup.parentId
                                      : package?.id
                                  }}" class="accordion-collapse collapse show">
                        <div class="featuutrebody row justify-content-center align-items-center" [style.background-color]="
                                      subgroup.backgroundColor
                                        ? subgroup.backgroundColor
                                        : defaultColor
                                    " *ngIf="subgroup">
                          <div class="col-3">
                            <div *ngIf="role==='ADMINISTRATOR' && package?.groups?.length >= 1"
                              title="{{getTextForTooltip(subgroup.published?.data[0],subgroup.restricted)}}"
                              [ngStyle]=" {'border-color' : getColorForPlans(subgroup.published?.data[0],subgroup.restricted) }"
                              class="outer my-auto col-2" data-bs-toggle="">
                              <span class="inner"
                                [ngStyle]="{ 'background': getColorForPlans(subgroup.published?.data[0],subgroup.restricted,subgroup.name) }"></span>
                            </div>
                          </div>
                          <span class="col-8">{{ subgroup.name }}</span>
                          <input type="checkbox" id="plancheck3Voluntry{{ subgroup.id }}" class=" col-1 plancheckbox3{{
                                        package?.id
                                      }} plancv largerCheckbox" attr.data="{{ package?.allowMultiple }}##{{
                                        subgroup.disallowedPlanLevels
                                      }}##{{ package?.id }}##{{
                                        subgroup.parentId
                                      }}##{{ subgroup.id }}##{{ package?.name }}##{{
                                        subgroup.name
                                      }}##{{ subgroup }}##{{ subgroup.ordering }}" (change)="
                                        onCheckboxChange3(
                                          $event,
                                          package?.allowMultiple,
                                          subgroup.disallowedPlanLevels,
                                          package?.id,
                                          subgroup.id,
                                          package?.name,
                                          subgroup.name,
                                          subgroup,
                                          subgroup.ordering,
                                          group.id,
                                          group.name,
                                          i,
                                          j,
                                          k
                                        )
                                      " />
                          <ng-container>
                            <div *ngIf="
                                          subgroup.coverage == '' && (subgroup.id == '17' || subgroup.id == '18' || subgroup.id == '28')
                                        ">
                              <form class="executiveplansselection">
                                <label class="radio-inline executiveplans">
                                  <input type="checkbox" name="executiveplansblock3{{
                                                subgroup.id
                                              }}" id="executiveplansblock3single{{
                                                subgroup.id
                                              }}" style="vertical-align: bottom" (click)="
                                                executiveplansCoverage3(
                                                  $event,
                                                  i,
                                                  j,
                                                  k,
                                                  subgroup.id
                                                )
                                              " />
                                  {{lang.Single}}
                                </label>
                                <label class="radio-inline executiveplans">
                                  <input type="checkbox" name="executiveplansblock3{{
                                                subgroup.id
                                              }}" id="executiveplansblock3couple{{
                                                subgroup.id
                                              }}" style="vertical-align: bottom" (click)="
                                                executiveplansCoverage3(
                                                  $event,
                                                  i,
                                                  j,
                                                  k,
                                                  subgroup.id
                                                )
                                              " />
                                  {{lang.Couple}}
                                </label>
                                <label class="radio-inline executiveplans">
                                  <input type="checkbox" name="executiveplansblock3{{
                                                subgroup.id
                                              }}" id="executiveplansblock3family{{
                                                subgroup.id
                                              }}" style="vertical-align: bottom" (click)="
                                                executiveplansCoverage3(
                                                  $event,
                                                  i,
                                                  j,
                                                  k,
                                                  subgroup.id
                                                )
                                              " />
                                  {{lang.Family}}
                                </label>
                              </form>
                            </div>
                            <div *ngIf="
                                          subgroup.coverage == 'Family' &&
                                          (subgroup.id == '17' || subgroup.id == '18' || subgroup.id == '28')
                                        ">

                            </div>

                            <div *ngIf="
                                          subgroup.coverage == '001' &&
                                           (subgroup.id == '17' || subgroup.id == '18' || subgroup.id == '28')
                                        ">
                              <form class="executiveplansselection">
                                <!-- <label class="radio-inline executiveplans">
                              <input type="radio" name="executiveplans" style="vertical-align: bottom;" value="Family" (click)="executiveplansCoverage3($event,i,j,k)"> Single
                            </label> -->
                                <label class="radio-inline executiveplans">
                                  <input type="checkbox" name="executiveplansblock3{{
                                                subgroup.id
                                              }}" id="executiveplansblock3couple{{
                                                subgroup.id
                                              }}" style="vertical-align: bottom" (click)="
                                                executiveplansCoverage3(
                                                  $event,
                                                  i,
                                                  j,
                                                  k,
                                                  subgroup.id
                                                )
                                              " />
                                  {{lang.Couple}}
                                </label>
                                <label class="radio-inline executiveplans">
                                  <input type="checkbox" name="executiveplansblock3{{
                                                subgroup.id
                                              }}" id="executiveplansblock3family{{
                                                subgroup.id
                                              }}" style="vertical-align: bottom" (click)="
                                                executiveplansCoverage3(
                                                  $event,
                                                  i,
                                                  j,
                                                  k,
                                                  subgroup.id
                                                )
                                              " />
                                  {{lang.Family}}
                                </label>
                              </form>
                            </div>
                            <div *ngIf="
                                          subgroup.coverage == '010' &&
                                          (subgroup.id == '17' || subgroup.id == '18' || subgroup.id == '28')

                                        ">
                              <form class="executiveplansselection">
                                <label class="radio-inline executiveplans">
                                  <input type="checkbox" name="executiveplansblock3{{
                                                subgroup.id
                                              }}" id="executiveplansblock3family{{
                                                subgroup.id
                                              }}" style="vertical-align: bottom" (click)="
                                                executiveplansCoverage3(
                                                  $event,
                                                  i,
                                                  j,
                                                  k,
                                                  subgroup.id
                                                )
                                              " />
                                  {{lang.Family}}
                                </label>
                                <!-- <label class="radio-inline executiveplans">
                              <input type="radio" name="executiveplans" style="vertical-align: bottom;" value="Couple" (click)="executiveplansCoverage3($event,i,j,k)"> Couple
                            </label> -->
                              </form>
                            </div>
                            <div *ngIf="
                                          subgroup.coverage == '011' &&
                                          (subgroup.id == '17' || subgroup.id == '18'|| subgroup.id == '28')

                                        ">
                              <form class="executiveplansselection">
                                <label class="radio-inline executiveplans">
                                  <input type="checkbox" name="executiveplansblock3{{
                                                subgroup.id
                                              }}" id="executiveplansblock3family{{
                                                subgroup.id
                                              }}" style="vertical-align: bottom" (click)="
                                                executiveplansCoverage3(
                                                  $event,
                                                  i,
                                                  j,
                                                  k,
                                                  subgroup.id
                                                )
                                              " />
                                  {{lang.Family}}
                                </label>
                                <!-- <label class="radio-inline executiveplans">
                          <input type="radio" name="executiveplans" style="vertical-align: bottom;" value="Couple" (click)="executiveplansCoverage3($event,i,j,k)"> Couple
                        </label> -->
                              </form>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                      <!-- <textarea type="text" class="tierconfig"> Employee</textarea> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- Block1 With With Tier -->
    <div class="row" *ngIf="showtieradvplans">
      <div class="packageWrapper plansscreen" *ngFor="let package of plansBlock1Tiers; let i = index">
        <div class="planheadingwrap" style="padding-left: 6px;">
          <h6 *ngIf="package?.groups.length <= 1" class="planheading panel-title"
            [attr.data-bs-target]="'#collapseadvone' + package?.id" data-bs-toggle="collapse" aria-expanded="true"
            aria-controls="collapseadvone{{ package?.id }}">
            {{ package?.name }}
          </h6>
          <!-- <h6 class="planheading" *ngIf="package?.groups?.length >  1">
                      {{ package?.name }}
                    </h6> -->
        </div>

        <div class="form-group package">
          <div class="package-groups1" *ngFor="let group of package?.groups; let j = index" title="">
            <div class="price" id="myGroup">
              <div class="header overflow-ellipsis1 panel-title" [attr.data-bs-target]="'#collapseadvone' + group.id"
                data-bs-toggle="collapse" aria-expanded="true" aria-controls="collapseone{{ group.id }}"
                title="{{ group.name }}" *ngIf="package?.groups?.length >  1">
                {{ group.name }}
              </div>
            </div>

            <div class="planbody" *ngIf="group.subGroups && group.subGroups.length > 0">
              <div *ngFor="let subgroup of group.subGroups; let k = index" id="collapseadvone{{
                            package?.groups?.length >  1
                              ? subgroup.parentId
                              : package?.id
                          }}" class="accordion-collapse collapse show">
                <div class="featuutrebody" [style.background-color]="
                              subgroup.backgroundColor
                                ? subgroup.backgroundColor
                                : defaultColor
                            ">
                  <span>{{ subgroup.name }}</span>
                  <input type="checkbox" id="plancheck{{ subgroup.id }}" class="plancheckbox{{
                                package?.id
                              }} plancv largerCheckbox block1tiers" attr.data="{{ package?.allowMultiple }}##{{
                                subgroup.disallowedPlanLevels
                              }}##{{ package?.id }}##{{ subgroup.parentId }}##{{
                                subgroup.id
                              }}##{{ package?.name }}##{{ subgroup.name }}##{{
                                subgroup
                              }}##{{ subgroup.ordering }}##{{ i }}##{{ j }}##{{
                                k
                              }}" (change)="
                                onCheckboxChange1Tier(
                                  $event,
                                  package?.allowMultiple,
                                  subgroup.disallowedPlanLevels,
                                  package?.id,
                                  subgroup.id,
                                  package?.name,
                                  subgroup.name,
                                  subgroup,
                                  subgroup.ordering,
                                  group.id,
                                  group.name,
                                  i,
                                  j,
                                  k,
                                  subgroup.backgroundColor
                                )
                              " />
                  <ng-container>
                    <!-- <div  *ngIf="subgroup.coverage=='default' && group.id=='15' && subgroup.checked"> -->


                    <div class="executiveplansselection" *ngIf="(subgroup.id == '17' || subgroup.id == '18')">
                      <label class="radio-inline executiveplans">
                        <input type="checkbox" name="executiveplans{{ subgroup.id }}"
                          id="executiveplansTiersingle{{ subgroup.id }}" style="vertical-align: bottom" (click)="
                                      executiveplansCoverageTier1(
                                        $event,
                                        i,
                                        j,
                                        k,
                                        subgroup.id
                                      )
                                    " />
                        Single
                      </label>
                      <label class="radio-inline executiveplans">
                        <input type="checkbox" name="executiveplans{{ subgroup.id }}"
                          id="executiveplansTiercouple{{ subgroup.id }}" style="vertical-align: bottom" (click)="
                                      executiveplansCoverageTier1(
                                        $event,
                                        i,
                                        j,
                                        k,
                                        subgroup.id
                                      )
                                    " />
                        Couple
                      </label>
                      <label class="radio-inline executiveplans">
                        <input type="checkbox" name="executiveplans{{ subgroup.id }}"
                          id="executiveplansTierfamily{{ subgroup.id }}" style="vertical-align: bottom" (click)="
                                      executiveplansCoverageTier1(
                                        $event,
                                        i,
                                        j,
                                        k,
                                        subgroup.id
                                      )
                                    " />
                        Family
                      </label>
                    </div>
                  </ng-container>
                </div>

                <ng-container>
                  <div class="tierconfig" *ngIf="
                                subgroup.tiers.length == 0 && subgroup.checked
                              ">
                    <ul class="tiersConfigul">
                      <li>Configure Tier</li>
                    </ul>
                  </div>
                </ng-container>

                <ng-container *ngIf="
                              subgroup.tiers &&
                              subgroup.tiers.length != null &&
                              subgroup.tiers != ''
                            ">
                  <div class="tierconfig">
                    <ul *ngFor="let tier of subgroup.tiers">
                      <li>{{ tier.name }}</li>
                    </ul>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-10"></div>
        <div class="form-group col-2">
          <button class="btn btn-primary" type="button" data-bs-toggle="modal" data-bs-target="#tierConfigure"
            *ngIf="showtieradvplans" style="float: right" (click)="configuretiers()">
            Configure&nbsp;&nbsp;<i aria-hidden="true" class="fa fa-long-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
    <!-- Block2 With With Tier -->
    <div class="row" *ngIf="showtieradvplans">
      <div class="form-group col-12">
        <span class="enabledplans1">Enabled?
          <input class="" type="radio" name="upgradeplanstiers" id="upgradeplanstierstrue" #upgradeplanstierstrue
            value="true" (click)="upgradeplansTiers($event)" />
          <label class="form-check-label" for="upgradeplanstiersyes" class="upgradeplans">&nbsp;Yes</label>&nbsp;&nbsp;
          <input class="" type="radio" name="upgradeplanstiers" id="upgradeplanstiersfalse" #upgradeplanstiersfalse
            value="false" (click)="upgradeplansTiers($event)" checked />
          <label class="form-check-label" for="upgradeplanstiersno" class="upgradeplans">&nbsp;No</label>
        </span>

        <h6 class="admintitle">
          Upgrade Plans (Premium difference paid by employee through
          payroll deduction).&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
        </h6>
      </div>
      <div class="row" *ngIf="upgradeplansselectiontiers">
        <div class="packageWrapper block2packagewrapper plansscreen2"
          *ngFor="let package of plansresblack2Tiers; let i = index">
          <div class="planheadingwrap" *ngIf="package" style="padding-left: 6px;">
            <!-- <div class="planheadingwrap" *ngIf="package"></div> -->
            <h6 *ngIf="package?.groups.length <= 1" class="planheading panel-title"
              [attr.data-bs-target]="'#collapseadvtwo' + package?.id" data-bs-toggle="collapse" aria-expanded="true"
              aria-controls="collapseadvtwo{{ package?.id }}">
              {{ package?.name }}
            </h6>
            <!-- <h6 class="planheading" *ngIf="package?.groups?.length >  1">
                        {{ package?.name }}
                      </h6> -->
            <!-- <h6 class="planheading">{{ package?.name }}<span *ngIf="package?.groups.length<=1" class="panel-title" [attr.data-bs-target]="'#collapseadvtwo'+package?.id" data-bs-toggle="collapse"   aria-expanded="true" aria-controls="collapseadvtwo{{package?.id}}"></span></h6> -->
          </div>
          <div class="form-group package" *ngIf="package">
            <div class="package-groups1" *ngFor="let group of package?.groups; let j = index" title="">
              <div class="price" *ngIf="group && group != null">
                <div class="header overflow-ellipsis1 panel-title" [attr.data-bs-target]="'#collapseadvtwo' + group.id"
                  data-bs-toggle="collapse" aria-expanded="true" aria-controls="collapseadvtwo{{ group.id }}"
                  title="{{ group.name }}" *ngIf="
                              group &&
                              group.subGroups &&
                              group.subGroups.length &&
                              package?.groups?.length >  1 > 0
                            ">
                  {{ group.name }}
                </div>
              </div>

              <div class="planbody" *ngIf="
                            group && group.subGroups && group.subGroups.length > 0
                          ">
                <div *ngFor="
                              let subgroup of group.subGroups;
                              let k = index
                            ">
                  <div *ngIf="subgroup" id="collapseadvtwo{{
                                package?.groups?.length >  1
                                  ? subgroup.parentId
                                  : package?.id
                              }}" class="accordion-collapse collapse show">
                    <div class="featuutrebody" [style.background-color]="
                                  subgroup.backgroundColor
                                    ? subgroup.backgroundColor
                                    : defaultColor
                                " *ngIf="subgroup">
                      <span>{{ subgroup.name }}</span>
                      <input type="checkbox" id="plancheck2Upgrade{{ subgroup.id }}" class="plancheckbox2{{
                                    package?.id
                                  }} plancheckbox2{{
                                    subgroup.id
                                  }} plancv largerCheckbox block2tiers" attr.data="{{ package?.allowMultiple }}##{{
                                    subgroup.disallowedPlanLevels
                                  }}##{{ package?.id }}##{{
                                    subgroup.parentId
                                  }}##{{ subgroup.id }}##{{ package?.name }}##{{
                                    subgroup.name
                                  }}##{{ subgroup }}##{{ subgroup.ordering }}##{{
                                    i
                                  }}##{{ j }}##{{ k }}" (change)="
                                    onCheckboxChange2Tier(
                                      $event,
                                      package?.allowMultiple,
                                      subgroup.disallowedPlanLevels,
                                      package?.id,
                                      subgroup.id,
                                      package?.name,
                                      subgroup.name,
                                      subgroup,
                                      subgroup.ordering,
                                      group.id,
                                      group.name,
                                      i,
                                      j,
                                      k,
                                      subgroup.backgroundColor
                                    )
                                  " />
                      <ng-container>
                        <div class="executiveplansselection" *ngIf="
                                      subgroup.coverage == '' && (subgroup.id == '17' || subgroup.id == '18')
                                    ">
                          <label class="radio-inline executiveplans">
                            <input type="checkbox" name="executiveplansblock2Tiers{{
                                          subgroup.id
                                        }}" id="executiveplansblock2Tiersingle{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverageTier2(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                            Single
                          </label>
                          <label class="radio-inline executiveplans">
                            <input type="checkbox" name="executiveplansblock2Tiers{{
                                          subgroup.id
                                        }}" id="executiveplansblock2Tiercouple{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverageTier2(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                            Couple
                          </label>
                          <label class="radio-inline executiveplans">
                            <input type="checkbox" name="executiveplansblock2Tiers{{
                                          subgroup.id
                                        }}" id="executiveplansblock2Tierfamily{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverageTier2(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                            Family
                          </label>
                        </div>

                        <div class="executiveplansselection" *ngIf="
                                      subgroup.coverage == 'Single' &&
                                      (subgroup.id == '17' || subgroup.id == '18')
                                    ">
                          <label class="radio-inline executiveplans">
                            <input type="checkbox" name="executiveplansblock2Tiers{{
                                          subgroup.id
                                        }}" id="executiveplansblock2Tiercouple{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverageTier2(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                            Couple
                          </label>
                          <label class="radio-inline executiveplans">
                            <input type="checkbox" name="executiveplansblock2Tiers{{
                                          subgroup.id
                                        }}" id="executiveplansblock2Tierfamily{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverageTier2(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                            Family
                          </label>
                        </div>
                        <div class="executiveplansselection" *ngIf="
                                      subgroup.coverage == 'Couple' &&
                                      (subgroup.id == '17' || subgroup.id == '18')
                                    ">
                          <label class="radio-inline executiveplans">
                            <input type="checkbox" name="executiveplansblock2Tiers{{
                                          subgroup.id
                                        }}" id="executiveplansblock2Tierfamily{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverageTier2(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                            Family
                          </label>
                        </div>
                      </ng-container>
                    </div>
                    <ng-container>
                      <div class="tierconfig" *ngIf="
                                    subgroup.tiers.length == 0 && subgroup.checked
                                  ">
                        <ul class="tiersConfigul">
                          <li>Configure Tier</li>
                        </ul>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="
                                  subgroup.tiers &&
                                  subgroup.tiers.length != null &&
                                  subgroup.tiers != ''
                                ">
                      <div class="tierconfig">
                        <ul *ngFor="let tier of subgroup.tiers">
                          <li>{{ tier.name }}</li>
                        </ul>
                      </div>
                    </ng-container>
                  </div>
                  <!-- <textarea type="text" class="tierconfig"> Employee</textarea> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-10"></div>
        <div class="form-group col-2">
          <button class="btn btn-primary" type="button" data-bs-toggle="modal" data-bs-target="#tierConfigureBlock2"
            *ngIf="upgradeplansselectiontiers" style="float: right" (click)="configuretiers()">
            Configure&nbsp;&nbsp;<i aria-hidden="true" class="fa fa-long-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
    <!-- Block3 With With Tier -->
    <div class="row" *ngIf="showtieradvplans">
      <div class="form-group col-12">
        <span class="enabledplans1">Enabled?
          <input class="" type="radio" name="employeepurchaseTiers" id="employeepurchaseTierstrue"
            #employeepurchaseTierstrue value="true" (click)="planpurchaseTiers($event)" />
          <label class="form-check-label" for="employeepurchasetierstrue"
            class="employeepurchase">&nbsp;Yes</label>&nbsp;&nbsp;
          <input class="" type="radio" name="employeepurchaseTiers" id="employeepurchaseTiersfalse"
            #employeepurchaseTiersfalse value="false" (click)="planpurchaseTiers($event)" checked />
          <label class="form-check-label" for="employeepurchasetiersfalse" class="employeepurchase">&nbsp;No</label>
        </span>
        <h6 class="admintitle">
          Voluntary Plans (Premium paid 100% by employee
          directly).&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
        </h6>
      </div>

      <div class="row" *ngIf="employeeplanpurchasetiers">
        <div class="packageWrapper block3packagewrapper plansscreen3"
          *ngFor="let package of plansresblack3Tiers; let i = index">
          <div class="planheadingwrap" style="padding-left: 6px;" *ngIf="
                        package &&
                        package?.id !== 1 &&
                        package &&
                        package?.id !== 4 &&
                        package &&
                        package?.id !== 5
                      ">
            <!-- <div class="planheadingwrap" *ngIf="package"></div> -->
            <h6 *ngIf="package?.groups.length <= 1" class="planheading panel-title"
              [attr.data-bs-target]="'#collapseadvthree' + package?.id" data-bs-toggle="collapse" aria-expanded="true"
              aria-controls="collapseadvthree{{ package?.id }}">
              {{ package?.name }}
            </h6>
            <!-- <h6 class="planheading" *ngIf="package?.groups?.length >  1">
                        {{ package?.name }}
                      </h6> -->
            <!-- <h6 class="planheading">{{ package?.name }}<span *ngIf="package?.groups.length<=1" class="panel-title" [attr.data-bs-target]="'#collapseadvtwo'+package?.id" data-bs-toggle="collapse"   aria-expanded="true" aria-controls="collapseadvtwo{{package?.id}}"></span></h6> -->
          </div>
          <div class="form-group package" *ngIf="
                        package &&
                        package?.id !== 1 &&
                        package &&
                        package?.id !== 4 &&
                        package &&
                        package?.id !== 5
                      ">
            <div class="package-groups1" *ngFor="let group of package?.groups; let j = index" title="">
              <div class="price" *ngIf="group && group != null">
                <div class="header overflow-ellipsis1 panel-title" [attr.data-bs-target]="'#collapseadvthree' + group.id"
                  data-bs-toggle="collapse" aria-expanded="true" aria-controls="collapseadvthree{{ group.id }}"
                  title="{{ group.name }}" *ngIf="
                              group &&
                              group.subGroups &&
                              group.subGroups.length &&
                              package?.groups?.length >  1 > 0
                            ">
                  {{ group.name }}
                </div>
              </div>

              <div class="planbody" *ngIf="
                            group && group.subGroups && group.subGroups.length > 0
                          ">
                <div *ngFor="
                              let subgroup of group.subGroups;
                              let k = index
                            ">
                  <div *ngIf="subgroup" id="collapseadvthree{{
                                package?.groups?.length >  1
                                  ? subgroup.parentId
                                  : package?.id
                              }}" class="accordion-collapse collapse show">
                    <div class="featuutrebody" [style.background-color]="
                                  subgroup.backgroundColor
                                    ? subgroup.backgroundColor
                                    : defaultColor
                                " *ngIf="subgroup">
                      <span>{{ subgroup.name }}</span>
                      <input type="checkbox" id="plancheck3Voluntry{{ subgroup.id }}" class="plancheckbox3{{
                                    package?.id
                                  }} plancv largerCheckbox block3tiers" attr.data="{{ package?.allowMultiple }}##{{
                                    subgroup.disallowedPlanLevels
                                  }}##{{ package?.id }}##{{
                                    subgroup.parentId
                                  }}##{{ subgroup.id }}##{{ package?.name }}##{{
                                    subgroup.name
                                  }}##{{ subgroup }}##{{ subgroup.ordering }}##{{
                                    i
                                  }}##{{ j }}##{{ k }}" (change)="
                                    onCheckboxChange3Tier(
                                      $event,
                                      package?.allowMultiple,
                                      subgroup.disallowedPlanLevels,
                                      package?.id,
                                      subgroup.id,
                                      package?.name,
                                      subgroup.name,
                                      subgroup,
                                      subgroup.ordering,
                                      group.id,
                                      group.name,
                                      i,
                                      j,
                                      k,
                                      subgroup.backgroundColor
                                    )
                                  " />
                      <ng-container>
                        <div class="executiveplansselection" *ngIf="
                                      subgroup.coverage == '' && (subgroup.id == '17' || subgroup.id == '18')
                                    ">
                          <label class="radio-inline executiveplans">
                            <input type="checkbox" name="executiveplansblock3Tiers{{
                                          subgroup.id
                                        }}" id="executiveplansblock3Tiersingle{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverageTier3(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                            Single
                          </label>
                          <label class="radio-inline executiveplans">
                            <input type="checkbox" name="executiveplansblock3Tiers{{
                                          subgroup.id
                                        }}" id="executiveplansblock3Tiercouple{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverageTier3(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                            Couple
                          </label>
                          <label class="radio-inline executiveplans">
                            <input type="checkbox" name="executiveplansblock3Tiers{{
                                          subgroup.id
                                        }}" id="executiveplansblock3Tierfamily{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverageTier3(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                            Family
                          </label>
                        </div>

                        <div class="executiveplansselection" *ngIf="
                                      subgroup.coverage == 'Single' &&
                                      (subgroup.id == '17' || subgroup.id == '18')
                                    ">
                          <label class="radio-inline executiveplans">
                            <input type="checkbox" name="executiveplansblock3Tiers{{
                                          subgroup.id
                                        }}" id="executiveplansblock3Tiercouple{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverageTier3(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                            Couple
                          </label>
                          <label class="radio-inline executiveplans">
                            <input type="checkbox" name="executiveplansblock3Tiers{{
                                          subgroup.id
                                        }}" id="executiveplansblock3Tierfamily{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverageTier3(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                            Family
                          </label>
                        </div>
                        <div class="executiveplansselection" *ngIf="
                                      subgroup.coverage == 'Couple' &&
                                      (subgroup.id == '17' || subgroup.id == '18')
                                    ">
                          <label class="radio-inline executiveplans">
                            <input type="checkbox" name="executiveplansblock3Tiers{{
                                          subgroup.id
                                        }}" id="executiveplansblock3Tierfamily{{
                                          subgroup.id
                                        }}" style="vertical-align: bottom" (click)="
                                          executiveplansCoverageTier3(
                                            $event,
                                            i,
                                            j,
                                            k,
                                            subgroup.id
                                          )
                                        " />
                            Family
                          </label>
                        </div>
                      </ng-container>
                    </div>
                    <ng-container>
                      <div class="tierconfig" *ngIf="
                                    subgroup.tiers.length == 0 && subgroup.checked
                                  ">
                        <ul class="tiersConfigul">
                          <li>Configure Tier</li>
                        </ul>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="
                                  subgroup.tiers &&
                                  subgroup.tiers.length != null &&
                                  subgroup.tiers != ''
                                ">
                      <div class="tierconfig">
                        <ul *ngFor="let tier of subgroup.tiers">
                          <li>{{ tier.name }}</li>
                        </ul>
                      </div>
                    </ng-container>
                  </div>
                  <!-- <textarea type="text" class="tierconfig"> Employee</textarea> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-10"></div>
        <div class="form-group col-2">
          <button class="btn btn-primary" type="button" data-bs-toggle="modal" data-bs-target="#tierConfigureBlock3"
            *ngIf="employeeplanpurchasetiers" style="float: right" (click)="configuretiers()">
            Configure&nbsp;&nbsp;<i aria-hidden="true" class="fa fa-long-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

      <!-- Plans screen footerpage -->

      <div class="d-flex justify-content-between mb-5" style="padding-top: 10px">
        <button class="saveAndNext" id="" type="button" (click)="gotodashboard()">
          <i aria-hidden="true" class="fa fa-long-arrow-left"></i>&nbsp;&nbsp;Go to DashBoard
        </button>

        <!-- <button class="saveAndNext" id="" type="button" [disabled]="plansButtonDisable" (click)="submitplansInfo()">
          {{lang.Save}}&nbsp;&nbsp;<i aria-hidden="true" class="fa fa-long-arrow-right"></i>
        </button> -->
        <button class="saveAndNext" id="" type="button" [disabled]="plansButtonDisable" (click)="commonPlans.submitplansInfo()">
          {{lang.Save}}&nbsp;&nbsp;<i aria-hidden="true" class="fa fa-long-arrow-right"></i>
        </button>
      </div>

    </div>

  </section>
</main>




<!-- Model For Tier Configuration for Block1 -->
<div class="modal fade" id="tierConfigure" tabindex="-1">
  <div class="modal-dialog model-lg modal-dialog-centered" style="width: 1250px">
    <div class="modal-content">
      <!-- <div class="modal-header">
           <h5 class="modal-title">Configure Tiers</h5>
           <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div> -->
      <div class="modal-body">
        <div id="carouselExampleFade" class="carousel slide carousel-fade" data-bs-interval="false">
          <div class="carousel-inner">
            <div class="carousel-item active" id="1">
              <form class="tierwalletInfo">
                <div class="row">
                  <div class="form-group col-12">
                    <!-- <h6 class="admintitle">Configure Tier GroupBenefitz Wallet<sup>TM</sup>Setup&nbsp;&nbsp;<i class="bi bi-info-circle"></i></h6> -->
                    <h6 class="configtiertable">
                      Configure Tier
                      <span *ngIf="showemptywalletConfig">GroupBenefitz Wallet<sup>TM</sup></span>
                      Setup&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
                    </h6>

                    <!-- <span style="color:black">Configure Tier GroupBenefitz Wallet<sup>TM</sup>Setup&nbsp;&nbsp;<i class="bi bi-info-circle"></i></span> -->
                    <h6 class="tiertable">
                      Tier Level
                      <span *ngIf="showemptywalletConfig">& Corresponding Wallet</span>
                      Setup&nbsp;&nbsp;<button class="addtierbutton" (click)="addRow()">
                        <strong>+&nbsp;Add</strong>
                      </button>

                      <!-- <h6 class="tiertable">Tier Level and Corresponding Wallet Setup&nbsp;&nbsp;<button  class="addtierbutton" (click)="addRow()" *ngIf="tiersLevelCheck"><strong>+&nbsp;Add</strong></button> -->

                      <!-- <span  class="enabledtierplans">
                        <input
                        class=""
                        type="radio"
                        name="tierlevels"
                        id="tierlevelstrue"
                        value="true"
                        (click)="tierslevel($event)"

                      />
                      <label class="form-check-label" for="tierlevelsfalse" class="walletConfigModel"
                        >&nbsp;Enable</label
                      >&nbsp;&nbsp;
                      <input
                      class=""
                      type="radio"
                      name="tierlevels"
                      id="tierlevelsfalse"
                      value="false"
                      (click)="tierslevel($event)" checked


                    />
                    <label class="form-check-label" for="tierlevelsfalse" class="walletConfigModel"
                      >&nbsp;Disable</label
                    >
                    </span> -->
                    </h6>

                    <table class="table table-striped table-bordered" style="width: 50%">
                      <thead>
                        <tr>
                          <th style="width: 5%"></th>
                          <!-- <th style="width: 10%;">S.NO</th> -->
                          <th style="width: 25%">Tier Name</th>
                          <th style="width: 20%" *ngIf="showemptywalletConfig">
                            Wallet Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let dynamic of dynamicArray; let i = index">
                          <td>
                            <button class="fa fa-trash-o deletetier" (click)="deleteRowBlock1(i, dynamic)"></button>
                          </td>
                          <!-- <td >
                          <input  style="text-align: center;"  class="form-control1" name="{{dynamic.sno}}" [(ngModel)]="dynamic.sno" [ngModelOptions]="{standalone: true}"   type="text" />
                        </td> -->
                          <td>
                            <input class="form-control1" name="{{ dynamic.tierName }}" [(ngModel)]="dynamic.tierName"
                              [ngModelOptions]="{ standalone: true }" type="text" placeholder="Enter Tier Name" />
                          </td>
                          <td *ngIf="showemptywalletConfig">
                            <input class="form-control1 TierAmount" name="{{ dynamic.walletAmount }}"
                              [(ngModel)]="dynamic.walletAmount" [ngModelOptions]="{ standalone: true }" type="text"
                              placeholder="" />
                          </td>
                        </tr>
                        <tr>
                          <!-- <td>
                          <button class="fa fa-plus " (click)="addRow()">Add</button>
                        </td> -->
                        </tr>
                      </tbody>
                    </table>

                    <h6 class="tiertable">
                      Length of Service
                      <span *ngIf="showemptywalletConfig">& Corresponding Wallet</span>
                      Setup&nbsp;&nbsp;<button class="addtierbutton" (click)="addRowService()"
                        *ngIf="lengthofServiceCheck">
                        <strong>+&nbsp;Add</strong>
                      </button>

                      <span class="enabledtierplans">
                        <input class="" type="radio" name="lengthOfService" id="lengthOfServicetrue"
                          #lengthOfServicetrue value="true" (click)="lengthOfService($event)" />
                        <label class="form-check-label" for="lengthOfService"
                          class="walletConfigModel">&nbsp;Enable</label>&nbsp;&nbsp;
                        <input class="" type="radio" name="lengthOfService" id="lengthOfServicefalse"
                          #lengthOfServicefalse value="false" (click)="lengthOfService($event)" checked />
                        <label class="form-check-label" for="lengthOfService"
                          class="walletConfigModel">&nbsp;Disable</label>
                      </span>
                    </h6>
                    <table class="table table-striped table-bordered" *ngIf="lengthofServiceCheck" style="width: 80%">
                      <thead>
                        <tr>
                          <th width="5%"></th>
                          <!-- <th width="10%">S.no</th> -->
                          <th width="25%">Tier Name</th>
                          <th width="15%">From</th>
                          <th width="15%">To</th>
                          <th width="15%"></th>
                          <th width="20%" *ngIf="showemptywalletConfig">
                            Wallet Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="
                            let dynamic of dynamicArrayService;
                            let i = index
                          ">
                          <td>
                            <button class="fa fa-trash-o deletetier"
                              (click)="deleteRowServiceBlock1(i, dynamic)"></button>
                          </td>
                          <!-- <td>
                            <input  style="text-align: center;"  class="form-control1" name="{{dynamic.sno}}" [(ngModel)]="dynamic.sno" [ngModelOptions]="{standalone: true}" (keypress)="numberOnly($event)"  type="text" />
                          </td> -->
                          <td>
                            <input class="form-control1" name="{{ dynamic.tierName }}" [(ngModel)]="dynamic.tierName"
                              [ngModelOptions]="{ standalone: true }" type="text" placeholder="Enter Tier Name" />
                          </td>
                          <td>
                            <input class="form-control1" name="{{ dynamic.from }}" [(ngModel)]="dynamic.from"
                              [ngModelOptions]="{ standalone: true }" (keypress)="numberOnly($event)" type="text"
                              placeholder="" />
                          </td>
                          <td>
                            <input class="form-control1" name="{{ dynamic.to }}" [(ngModel)]="dynamic.to"
                              [ngModelOptions]="{ standalone: true }" (keypress)="numberOnly($event)" type="text"
                              placeholder="" />
                          </td>
                          <td>
                            <select class="form-control1" id="lengthofService" name="{{ dynamic.period }}"
                              [(ngModel)]="dynamic.period" [ngModelOptions]="{ standalone: true }">
                              <option [value]="null" disabled>Select</option>
                              <option value="years">Years</option>
                              <option value="months">Months</option>
                            </select>
                          </td>
                          <td *ngIf="showemptywalletConfig">
                            <input class="form-control1 TierAmount" name="{{ dynamic.walletAmount }}"
                              [(ngModel)]="dynamic.walletAmount" [ngModelOptions]="{ standalone: true }" type="text" />
                          </td>
                        </tr>
                        <tr>
                          <!-- <td>
                            <button class="fa fa-plus " (click)="addRow()">Add</button>
                          </td> -->
                        </tr>
                      </tbody>
                    </table>

                    <div *ngIf="showemptywalletConfig">
                      <h6 class="tiertable">
                        % of Annual income & Wallet Setup&nbsp;&nbsp;<button class="addtierbutton"
                          (click)="addRowAnnual()" *ngIf="annualincomeCheck">
                          <strong>+&nbsp;Add</strong>
                        </button>

                        <span class="enabledtierplans">
                          <input class="" type="radio" name="annualIncome" id="annualIncometrue" #annualIncometrue
                            value="true" (click)="annualIncome($event)" />
                          <label class="form-check-label" for="workinghoursno"
                            class="walletConfigModel">&nbsp;Enable</label>&nbsp;&nbsp;
                          <input class="" type="radio" name="annualIncome" id="annualIncomefalse" #annualIncomefalse
                            value="false" (click)="annualIncome($event)" checked />
                          <label class="form-check-label" for="workinghoursno"
                            class="walletConfigModel">&nbsp;Disable</label>
                        </span>
                      </h6>
                      <table class="table table-striped table-bordered" *ngIf="annualincomeCheck" style="width: 80%">
                        <thead>
                          <tr>
                            <th width="5%"></th>
                            <!-- <th width="10%">S.no</th> -->
                            <th width="25%">Tier Name</th>
                            <th width="15%">%</th>
                            <th width="15%">From</th>
                            <th width="15%">To</th>
                            <th width="20%" *ngIf="showemptywalletConfig">
                              Wallet Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="
                              let dynamic of dynamicArrayAnnualIncome;
                              let i = index
                            ">
                            <td>
                              <button class="fa fa-trash-o deletetier"
                                (click)="deleteRowAnnualBlock1(i, dynamic)"></button>
                            </td>
                            <!-- <td>
                              <input  style="text-align: center;"  class="form-control1" name="{{dynamic.sno}}" [(ngModel)]="dynamic.sno" [ngModelOptions]="{standalone: true}" (keypress)="numberOnly($event)"  type="text" />
                            </td> -->
                            <td>
                              <input class="form-control1" name="{{ dynamic.tierName }}" [(ngModel)]="dynamic.tierName"
                                [ngModelOptions]="{ standalone: true }" type="text" placeholder="Enter Tier Name" />
                            </td>
                            <td>
                              <input class="form-control1" name="{{ dynamic.percentage }}"
                                [(ngModel)]="dynamic.percentage" [ngModelOptions]="{ standalone: true }" type="text"
                                placeholder="" />
                            </td>

                            <td>
                              <input class="form-control1" name="{{ dynamic.from }}" [(ngModel)]="dynamic.from"
                                [ngModelOptions]="{ standalone: true }" type="text" placeholder="" />
                            </td>
                            <td>
                              <input class="form-control1" name="{{ dynamic.to }}" [(ngModel)]="dynamic.to"
                                [ngModelOptions]="{ standalone: true }" type="text" placeholder="" />
                            </td>
                            <td *ngIf="showemptywalletConfig">
                              <input class="form-control1 TierAmount" name="{{ dynamic.walletAmount }}"
                                [(ngModel)]="dynamic.walletAmount" [ngModelOptions]="{ standalone: true }"
                                type="text" />
                            </td>
                            <td style="display: none">
                              <input type="hidden" class="form-control1" name="{{ dynamic.annualIncome }}"
                                [(ngModel)]="dynamic.annualIncome" [ngModelOptions]="{ standalone: true }" type="number"
                                placeholder="" />
                            </td>
                          </tr>
                          <tr>
                            <!-- <td>
                              <button class="fa fa-plus " (click)="addRow()">Add</button>
                            </td> -->
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div style="margin-top: 10px">
                      <!-- <button type="button" class="btn btn-danger tierClose">Close</button> -->
                      <button type="button" class="btn btn-primary tierSave" (click)="submitTierInfo()">
                        Save
                      </button>

                      <button type="button" style="margin-right: 5px" class="btn btn closemodel"
                        data-bs-dismiss="modal">
                        Close</button>&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="carousel-item" id="2">
              <form class="tierwalletInfo12">
                <div class="row">
                  <div class="form-group col-12">
                    <h6 class="configtiertable">
                      Configure Tiers, Assign Selected Plans to
                      Tiers&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
                    </h6>

                    <!-- <span style="color:black">Configure Tiers, Assign Selected Plans to Tiers&nbsp;&nbsp;<i class="bi bi-info-circle"></i></span> -->
                    <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->

                    <!-- <h6 class="admintitle">Configure Tiers, Assign Selected Plans to Tiers&nbsp;&nbsp;<i class="bi bi-info-circle"></i></h6> -->
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-12" style="overflow: scroll" *ngIf="showtierbasicplans">
                    <ng-container *ngFor="let item of selectionTiers | keyvalue">
                      <div class="row plansscreen">
                        <div class="form-row">
                          <h6 class="tiergroupname">{{ item.key }}</h6>
                        </div>
                        <div class="form-group package">
                          <ng-container class="tierpackagegroups" *ngFor="let planLevel of item.value">
                            <div class="tiersubgroup">
                              <div>
                                <div class="container">
                                  <div class="tierplanselection">
                                    {{ planLevel.subGrpname }}
                                  </div>

                                  <div class="flex-item tierslection">
                                    <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="dropdownSettings"
                                      [data]="configureTierList" (onSelect)="
                                        onItemSelect(
                                          $event,
                                          planLevel.packageid,
                                          planLevel.parentId,
                                          planLevel.subGroupId,
                                          planLevel.packageindex,
                                          planLevel.groupindex,
                                          planLevel.subgroupindex
                                        )
                                      " (onSelectAll)="
                                        onSelectAll(
                                          $event,
                                          planLevel.packageid,
                                          planLevel.parentId,
                                          planLevel.subGroupId,
                                          planLevel.packageindex,
                                          planLevel.groupindex,
                                          planLevel.subgroupindex
                                        )
                                      " (onDeSelect)="
                                        onItemDeSelect(
                                          $event,
                                          planLevel.packageid,
                                          planLevel.parentId,
                                          planLevel.subGroupId,
                                          planLevel.packageindex,
                                          planLevel.groupindex,
                                          planLevel.subgroupindex
                                        )
                                      " (onDeSelectAll)="
                                        onDeSelectAll(
                                          $event,
                                          planLevel.packageid,
                                          planLevel.parentId,
                                          planLevel.subGroupId,
                                          planLevel.packageindex,
                                          planLevel.groupindex,
                                          planLevel.subgroupindex
                                        )
                                      ">
                                    </ng-multiselect-dropdown>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </ng-container>
                  </div>

                  <div class="form-group col-12" style="overflow: scroll; height: 450px" *ngIf="showtieradvplans">
                    <div *ngFor="
                        let item of selectedPackagePlansInfoTier | keyvalue
                      ">
                      <!-- *ngIf="item.value.length>0" -->

                      <div class="row plansscreen">
                        <div class="form-row">
                          <!-- <h6 class="tiergroupname">{{selectedPackagePlansInfoTiername[item.key]}}</h6> -->

                          <h6 class="tiergroupname" *ngIf="item.value.length > 0">
                            {{ item.key }}
                          </h6>
                        </div>
                        <div class="form-group packageadv" *ngFor="let planLevel of item.value">
                          <div class="row">
                            <div class="col-3">
                              <div class="tierplanselection" [style.background-color]="
                                  planLevel.backgroundColor
                                    ? planLevel.backgroundColor
                                    : defaultColor
                                ">
                                {{ planLevel.subGroupName }}
                              </div>
                            </div>

                            <div class="col-4">
                              <ng-multiselect-dropdown *ngIf="showinput" [placeholder]="'Select'" [closeOnSelect]="true"
                                [settings]="dropdownSettings" [data]="
                                  selectedPackagesavailableTiers2[
                                    planLevel.packageId
                                  ][planLevel.subGroupid] || configureTierList
                                " [(ngModel)]="
                                  selectedPackagesassignedTiers2[
                                    planLevel.packageId
                                  ][planLevel.subGroupid]
                                " name="tierselection" (onSelect)="
                                  onItemSelectTiers($event, planLevel)
                                " (onDeSelect)="
                                  onItemremoveTiers($event, planLevel)
                                " (click)="checkhere()">
                              </ng-multiselect-dropdown>

                              <ng-multiselect-dropdown *ngIf="showinput1" [placeholder]="'Select'"
                                [closeOnSelect]="true" [settings]="dropdownSettings" [data]="
                                  selectedPackagesavailableTiers21[
                                    planLevel.packageId
                                  ][planLevel.subGroupid] || configureTierList
                                " [(ngModel)]="
                                  selectedPackagesassignedTiers2[
                                    planLevel.packageId
                                  ][planLevel.subGroupid]
                                " name="tierselection" (onSelect)="
                                  onItemSelectTiers($event, planLevel)
                                " (onDeSelect)="
                                  onItemremoveTiers($event, planLevel)
                                " (click)="checkhere()">
                              </ng-multiselect-dropdown>
                            </div>
                            <div class="col-5"></div>

                            <!-- <div class="flex-item tierslection">
                      </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="float: right; margin-bottom: 10px; margin-top: 10px">
                  <!-- <button type="button" class="btn btn-primary tierClose">Cancel</button> -->
                  <!-- <button type="button" class="btn btn-success tierconfigcancel">Cancel</button> -->

                  <!-- <button type="button" class="btn btn-dark" (click)="showSlectedPlansTiers()">Done</button> -->
                </div>
              </form>
              <div class="modal-footer">
                <button type="button" class="btn btn closemodel" data-bs-dismiss="modal">
                  Close
                </button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="showSlectedPlansTiers()">
                  Save
                </button>

                <!-- </div> -->
              </div>
            </div>
          </div>
          <!-- <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev"> -->
          <span class="carousel-control-prev-icon carousel-control-prev" aria-hidden="true"
            data-bs-target="#carouselExampleFade" data-bs-slide="prev"></span>

          <!-- </button> -->
          <!-- <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next"> -->
          <span class="carousel-control-next-icon carousel-control-next" #nextpage aria-hidden="true"
            data-bs-target="#carouselExampleFade" data-bs-slide="next"></span>

          <!-- </button> -->
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Model For Tier Configuration for Block2 -->
<div class="modal fade" id="tierConfigureBlock2" tabindex="-1">
  <div class="modal-dialog model-lg modal-dialog-centered" style="width: 1250px">
    <div class="modal-content">
      <div class="modal-body">
        <div id="carouselExampleFadeBlock2" class="carousel slide carousel-fade" data-bs-interval="false">
          <div class="carousel-inner">
            <div class="carousel-item active">
              <form class="tierwalletInfo">
                <div class="row">
                  <div class="form-group col-12">
                    <!-- <h6 class="admintitle">Configure Tier GroupBenefitz Wallet<sup>TM</sup>Setup&nbsp;&nbsp;<i class="bi bi-info-circle"></i></h6> -->
                    <h6 class="configtiertable">
                      Configure Tier<span *ngIf="showemptywalletConfig">GroupBenefitz
                        Wallet<sup>TM</sup></span>Setup&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
                    </h6>

                    <!-- <span style="color:black">Configure Tier GroupBenefitz Wallet<sup>TM</sup>Setup&nbsp;&nbsp;<i class="bi bi-info-circle"></i></span> -->
                    <h6 class="tiertable">
                      Tier Level
                      <span *ngIf="showemptywalletConfig">& Corresponding Wallet</span>
                      Setup&nbsp;&nbsp;<button class="addtierbutton" (click)="addRow()">
                        <strong>+&nbsp;Add</strong>
                      </button>

                      <!-- <h6 class="tiertable">Tier Level and Corresponding Wallet Setup&nbsp;&nbsp;<button  class="addtierbutton" (click)="addRow()" *ngIf="tiersLevelCheck"><strong>+&nbsp;Add</strong></button> -->

                      <!-- <span  class="enabledtierplans">
                          <input
                          class=""
                          type="radio"
                          name="tierlevels"
                          id="tierlevelstrue"
                          value="true"
                          (click)="tierslevel($event)"

                        />
                        <label class="form-check-label" for="tierlevelsfalse" class="walletConfigModel"
                          >&nbsp;Enable</label
                        >&nbsp;&nbsp;
                        <input
                        class=""
                        type="radio"
                        name="tierlevels"
                        id="tierlevelsfalse"
                        value="false"
                        (click)="tierslevel($event)" checked


                      />
                      <label class="form-check-label" for="tierlevelsfalse" class="walletConfigModel"
                        >&nbsp;Disable</label
                      >
                      </span> -->
                    </h6>

                    <table class="table table-striped table-bordered" style="width: 50%">
                      <thead>
                        <tr>
                          <th style="width: 5%"></th>
                          <!-- <th style="width: 10%;">S.NO</th> -->
                          <th style="width: 25%">Tier Name</th>
                          <th style="width: 20%" *ngIf="showemptywalletConfig">
                            Wallet Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let dynamic of dynamicArray; let i = index">
                          <td>
                            <button class="fa fa-trash-o deletetier" (click)="deleteRowBlock2(i, dynamic)"></button>
                          </td>
                          <!-- <td >
                            <input  style="text-align: center;"  class="form-control1" name="{{dynamic.sno}}" [(ngModel)]="dynamic.sno" [ngModelOptions]="{standalone: true}"   type="text" />
                          </td> -->
                          <td>
                            <input class="form-control1" name="{{ dynamic.tierName }}" [(ngModel)]="dynamic.tierName"
                              [ngModelOptions]="{ standalone: true }" type="text" placeholder="Enter Tier Name" />
                          </td>
                          <td *ngIf="showemptywalletConfig">
                            <input class="form-control1 TierAmount" name="{{ dynamic.walletAmount }}"
                              [(ngModel)]="dynamic.walletAmount" [ngModelOptions]="{ standalone: true }" type="text"
                              placeholder="" />
                          </td>
                        </tr>
                        <tr>
                          <!-- <td>
                            <button class="fa fa-plus " (click)="addRow()">Add</button>
                          </td> -->
                        </tr>
                      </tbody>
                    </table>

                    <h6 class="tiertable">
                      Length of Service
                      <span *ngIf="showemptywalletConfig">& Corresponding Wallet</span>
                      Setup&nbsp;&nbsp;<button class="addtierbutton" (click)="addRowService()"
                        *ngIf="lengthofServiceCheck">
                        <strong>+&nbsp;Add</strong>
                      </button>

                      <span class="enabledtierplans">
                        <input class="" type="radio" name="lengthOfService" id="lengthOfServicetrue" value="true"
                          (click)="lengthOfService($event)" />
                        <label class="form-check-label" for="lengthOfService"
                          class="walletConfigModel">&nbsp;Enable</label>&nbsp;&nbsp;
                        <input class="" type="radio" name="lengthOfService" id="lengthOfServicefalse" value="false"
                          (click)="lengthOfService($event)" checked />
                        <label class="form-check-label" for="lengthOfService"
                          class="walletConfigModel">&nbsp;Disable</label>
                      </span>
                    </h6>
                    <table class="table table-striped table-bordered" *ngIf="lengthofServiceCheck" style="width: 80%">
                      <thead>
                        <tr>
                          <th width="5%"></th>
                          <!-- <th width="10%">S.no</th> -->
                          <th width="25%">Tier Name</th>
                          <th width="15%">From</th>
                          <th width="15%">To</th>
                          <th width="15%"></th>
                          <th width="20%" *ngIf="showemptywalletConfig">
                            Wallet Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="
                            let dynamic of dynamicArrayService;
                            let i = index
                          ">
                          <td>
                            <button class="fa fa-trash-o deletetier"
                              (click)="deleteRowServiceBlock2(i, dynamic)"></button>
                          </td>
                          <!-- <td>
                              <input  style="text-align: center;"  class="form-control1" name="{{dynamic.sno}}" [(ngModel)]="dynamic.sno" [ngModelOptions]="{standalone: true}" (keypress)="numberOnly($event)"  type="text" />
                            </td> -->
                          <td>
                            <input class="form-control1" name="{{ dynamic.tierName }}" [(ngModel)]="dynamic.tierName"
                              [ngModelOptions]="{ standalone: true }" type="text" placeholder="Enter Tier Name" />
                          </td>
                          <td>
                            <input class="form-control1" name="{{ dynamic.from }}" [(ngModel)]="dynamic.from"
                              [ngModelOptions]="{ standalone: true }" (keypress)="numberOnly($event)" type="text"
                              placeholder="" />
                          </td>
                          <td>
                            <input class="form-control1" name="{{ dynamic.to }}" [(ngModel)]="dynamic.to"
                              [ngModelOptions]="{ standalone: true }" (keypress)="numberOnly($event)" type="text"
                              placeholder="" />
                          </td>
                          <td>
                            <select class="form-control1" id="lengthofService" name="{{ dynamic.period }}"
                              [(ngModel)]="dynamic.period" [ngModelOptions]="{ standalone: true }">
                              <option [value]="null" disabled>Select</option>
                              <option value="years" [selected]="isSelected">
                                Years
                              </option>
                              <option value="months">Months</option>
                            </select>
                          </td>
                          <td *ngIf="showemptywalletConfig">
                            <input class="form-control1 TierAmount" name="{{ dynamic.walletAmount }}"
                              [(ngModel)]="dynamic.walletAmount" [ngModelOptions]="{ standalone: true }" type="text" />
                          </td>
                        </tr>
                        <tr>
                          <!-- <td>
                              <button class="fa fa-plus " (click)="addRow()">Add</button>
                            </td> -->
                        </tr>
                      </tbody>
                    </table>

                    <div *ngIf="showemptywalletConfig">
                      <h6 class="tiertable">
                        % of Annual income & Wallet Setup&nbsp;&nbsp;<button class="addtierbutton"
                          (click)="addRowAnnual()" *ngIf="annualincomeCheck">
                          <strong>+&nbsp;Add</strong>
                        </button>

                        <span class="enabledtierplans">
                          <input class="" type="radio" name="annualIncome" id="annualIncometrue" value="true"
                            (click)="annualIncome($event)" />
                          <label class="form-check-label" for="workinghoursno"
                            class="walletConfigModel">&nbsp;Enable</label>&nbsp;&nbsp;
                          <input class="" type="radio" name="annualIncome" id="annualIncomefalse" value="false"
                            (click)="annualIncome($event)" checked />
                          <label class="form-check-label" for="workinghoursno"
                            class="walletConfigModel">&nbsp;Disable</label>
                        </span>
                      </h6>
                      <table class="table table-striped table-bordered" *ngIf="annualincomeCheck" style="width: 80%">
                        <thead>
                          <tr>
                            <th width="5%"></th>
                            <!-- <th width="10%">S.no</th> -->
                            <th width="25%">Tier Name</th>
                            <th width="15%">%</th>
                            <th width="15%">From</th>
                            <th width="15%">To</th>
                            <th width="20%" *ngIf="showemptywalletConfig">
                              Wallet Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="
                              let dynamic of dynamicArrayAnnualIncome;
                              let i = index
                            ">
                            <td>
                              <button class="fa fa-trash-o deletetier"
                                (click)="deleteRowAnnualBlock2(i, dynamic)"></button>
                            </td>
                            <!-- <td>
                                <input  style="text-align: center;"  class="form-control1" name="{{dynamic.sno}}" [(ngModel)]="dynamic.sno" [ngModelOptions]="{standalone: true}" (keypress)="numberOnly($event)"  type="text" />
                              </td> -->
                            <td>
                              <input class="form-control1" name="{{ dynamic.tierName }}" [(ngModel)]="dynamic.tierName"
                                [ngModelOptions]="{ standalone: true }" type="text" placeholder="Enter Tier Name" />
                            </td>
                            <td>
                              <input class="form-control1" name="{{ dynamic.percentage }}"
                                [(ngModel)]="dynamic.percentage" [ngModelOptions]="{ standalone: true }" type="text"
                                placeholder="" />
                            </td>

                            <td>
                              <input class="form-control1" name="{{ dynamic.from }}" [(ngModel)]="dynamic.from"
                                [ngModelOptions]="{ standalone: true }" type="text" placeholder="" />
                            </td>
                            <td>
                              <input class="form-control1" name="{{ dynamic.to }}" [(ngModel)]="dynamic.to"
                                [ngModelOptions]="{ standalone: true }" type="text" placeholder="" />
                            </td>
                            <td *ngIf="showemptywalletConfig">
                              <input class="form-control1 TierAmount" name="{{ dynamic.walletAmount }}"
                                [(ngModel)]="dynamic.walletAmount" [ngModelOptions]="{ standalone: true }"
                                type="text" />
                            </td>
                            <td style="display: none">
                              <input type="hidden" class="form-control1" name="{{ dynamic.annualIncome }}"
                                [(ngModel)]="dynamic.annualIncome" [ngModelOptions]="{ standalone: true }" type="number"
                                placeholder="" />
                            </td>
                          </tr>
                          <tr>
                            <!-- <td>
                                <button class="fa fa-plus " (click)="addRow()">Add</button>
                              </td> -->
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div style="margin-top: 10px">
                      <!-- <button type="button" class="btn btn-danger tierClose">Close</button> -->
                      <button type="button" class="btn btn-primary tierSave" (click)="submitTierInfo()">
                        Save
                      </button>

                      <button type="button" style="margin-right: 5px" class="btn btn closemodel"
                        data-bs-dismiss="modal">
                        Close</button>&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="carousel-item">
              <form class="tierwalletInfo12">
                <div class="row">
                  <div class="form-group col-12">
                    <h6 class="configtiertable">
                      Configure Tiers, Assign Selected Plans to
                      Tiers&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
                    </h6>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-12" style="overflow: scroll" *ngIf="showtierbasicplans">
                    <ng-container *ngFor="let item of selectionTiers | keyvalue">
                      <div class="row plansscreen">
                        <div class="form-row">
                          <h6 class="tiergroupname">{{ item.key }}</h6>
                        </div>
                        <div class="form-group package">
                          <ng-container class="tierpackagegroups" *ngFor="let planLevel of item.value">
                            <div class="tiersubgroup">
                              <div>
                                <div class="container">
                                  <div class="tierplanselection">
                                    {{ planLevel.subGrpname }}
                                  </div>

                                  <div class="flex-item tierslection">
                                    <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="dropdownSettings"
                                      [data]="configureTierList" (onSelect)="
                                        onItemSelect(
                                          $event,
                                          planLevel.packageid,
                                          planLevel.parentId,
                                          planLevel.subGroupId,
                                          planLevel.packageindex,
                                          planLevel.groupindex,
                                          planLevel.subgroupindex
                                        )
                                      " (onSelectAll)="
                                        onSelectAll(
                                          $event,
                                          planLevel.packageid,
                                          planLevel.parentId,
                                          planLevel.subGroupId,
                                          planLevel.packageindex,
                                          planLevel.groupindex,
                                          planLevel.subgroupindex
                                        )
                                      " (onDeSelect)="
                                        onItemDeSelect(
                                          $event,
                                          planLevel.packageid,
                                          planLevel.parentId,
                                          planLevel.subGroupId,
                                          planLevel.packageindex,
                                          planLevel.groupindex,
                                          planLevel.subgroupindex
                                        )
                                      " (onDeSelectAll)="
                                        onDeSelectAll(
                                          $event,
                                          planLevel.packageid,
                                          planLevel.parentId,
                                          planLevel.subGroupId,
                                          planLevel.packageindex,
                                          planLevel.groupindex,
                                          planLevel.subgroupindex
                                        )
                                      ">
                                    </ng-multiselect-dropdown>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </ng-container>
                  </div>

                  <div class="form-group col-12" style="overflow: scroll; height: 450px" *ngIf="showtieradvplans">
                    <div *ngFor="
                        let item of selectedPackagePlansInfoTierBlock2
                          | keyvalue
                      ">
                      <!-- *ngIf="item.value.length>0" -->

                      <div class="row plansscreen">
                        <div class="form-row">
                          <!-- <h6 class="tiergroupname">{{selectedPackagePlansInfoTiername[item.key]}}</h6> -->

                          <h6 class="tiergroupname">{{ item.key }}</h6>
                        </div>
                        <div class="form-group packageadv" *ngFor="let planLevel of item.value">
                          <div class="row">
                            <div class="col-3">
                              <div class="tierplanselection" [style.background-color]="
                                  planLevel.backgroundColor
                                    ? planLevel.backgroundColor
                                    : defaultColor
                                ">
                                {{ planLevel.subGroupName }}
                              </div>
                            </div>

                            <div class="col-4">
                              <ng-multiselect-dropdown *ngIf="showinputBlock2" [placeholder]="'Select'"
                                [closeOnSelect]="true" name="tierselection" [settings]="dropdownSettings" [data]="
                                  selectedPackagesavailableTiers2Block2[
                                    planLevel.packageId
                                  ][planLevel.subGroupid] || configureTierList
                                " [(ngModel)]="
                                  selectedPackagesassignedTiers2Block2[
                                    planLevel.packageId
                                  ][planLevel.subGroupid]
                                " (onSelect)="
                                  onItemSelectTiersBlock2($event, planLevel)
                                " (onDeSelect)="
                                  onItemremoveTiersBlock2($event, planLevel)
                                ">
                              </ng-multiselect-dropdown>

                              <ng-multiselect-dropdown *ngIf="showinput1Block2" [placeholder]="'Select'"
                                [closeOnSelect]="true" name="tierselection" [settings]="dropdownSettings" [data]="
                                  selectedPackagesavailableTiers2Block21[
                                    planLevel.packageId
                                  ][planLevel.subGroupid] || configureTierList
                                " [(ngModel)]="
                                  selectedPackagesassignedTiers2Block21[
                                    planLevel.packageId
                                  ][planLevel.subGroupid]
                                " (onSelect)="
                                  onItemSelectTiersBlock2($event, planLevel)
                                " (onDeSelect)="
                                  onItemremoveTiersBlock2($event, planLevel)
                                ">
                              </ng-multiselect-dropdown>
                            </div>
                            <div class="col-5"></div>

                            <!-- <div class="flex-item tierslection">
                        </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <div class="modal-footer">
                <button type="button" class="btn btn closemodel" data-bs-dismiss="modal">
                  Close
                </button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                  (click)="showSlectedPlansTiersBlock2()">
                  Save
                </button>

                <!-- </div> -->
              </div>
            </div>
          </div>
          <span class="carousel-control-prev-icon carousel-control-prev" aria-hidden="true"
            data-bs-target="#carouselExampleFadeBlock2" data-bs-slide="prev"></span>

          <span class="carousel-control-next-icon carousel-control-next" #nextpage aria-hidden="true"
            data-bs-target="#carouselExampleFadeBlock2" data-bs-slide="next"></span>

          <!-- </button> -->
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Model For Tier Configuration for Block3 -->
<div class="modal fade" id="tierConfigureBlock3" tabindex="-1">
  <div class="modal-dialog model-lg modal-dialog-centered" style="width: 1250px">
    <div class="modal-content">
      <div class="modal-body">
        <div id="carouselExampleFadeBlock3" class="carousel slide carousel-fade" data-bs-interval="false">
          <div class="carousel-inner">
            <div class="carousel-item active">
              <form class="tierwalletInfo">
                <div class="row">
                  <div class="form-group col-12">
                    <!-- <h6 class="admintitle">Configure Tier GroupBenefitz Wallet<sup>TM</sup>Setup&nbsp;&nbsp;<i class="bi bi-info-circle"></i></h6> -->
                    <h6 class="configtiertable">
                      Configure Tier<span *ngIf="showemptywalletConfig">GroupBenefitz
                        Wallet<sup>TM</sup></span>Setup&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
                    </h6>

                    <!-- <span style="color:black">Configure Tier GroupBenefitz Wallet<sup>TM</sup>Setup&nbsp;&nbsp;<i class="bi bi-info-circle"></i></span> -->
                    <h6 class="tiertable">
                      Tier Level
                      <span *ngIf="showemptywalletConfig">& Corresponding Wallet</span>
                      Setup&nbsp;&nbsp;<button class="addtierbutton" (click)="addRow()">
                        <strong>+&nbsp;Add</strong>
                      </button>
                    </h6>

                    <table class="table table-striped table-bordered" style="width: 50%">
                      <thead>
                        <tr>
                          <th style="width: 5%"></th>
                          <!-- <th style="width: 10%;">S.NO</th> -->
                          <th style="width: 25%">Tier Name</th>
                          <th style="width: 25%" *ngIf="showemptywalletConfig">
                            Wallet Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let dynamic of dynamicArray; let i = index">
                          <td>
                            <button class="fa fa-trash-o deletetier" (click)="deleteRowBlock3(i, dynamic)"></button>
                          </td>
                          <!-- <td >
                              <input  style="text-align: center;"  class="form-control1" name="{{dynamic.sno}}" [(ngModel)]="dynamic.sno" [ngModelOptions]="{standalone: true}"   type="text" />
                            </td> -->
                          <td>
                            <input class="form-control1" name="{{ dynamic.tierName }}" [(ngModel)]="dynamic.tierName"
                              [ngModelOptions]="{ standalone: true }" type="text" placeholder="Enter Tier Name" />
                          </td>
                          <td *ngIf="showemptywalletConfig">
                            <input class="form-control1 TierAmount" name="{{ dynamic.walletAmount }}"
                              [(ngModel)]="dynamic.walletAmount" [ngModelOptions]="{ standalone: true }" type="text"
                              placeholder="" />
                          </td>
                        </tr>
                        <tr>
                          <!-- <td>
                              <button class="fa fa-plus " (click)="addRow()">Add</button>
                            </td> -->
                        </tr>
                      </tbody>
                    </table>

                    <h6 class="tiertable">
                      Length of Service
                      <span *ngIf="showemptywalletConfig">& Corresponding Wallet</span>
                      Setup&nbsp;&nbsp;<button class="addtierbutton" (click)="addRowService()"
                        *ngIf="lengthofServiceCheck">
                        <strong>+&nbsp;Add</strong>
                      </button>

                      <span class="enabledtierplans">
                        <input class="" type="radio" name="lengthOfService" id="lengthOfServicetrue" value="true"
                          (click)="lengthOfService($event)" />
                        <label class="form-check-label" for="lengthOfService"
                          class="walletConfigModel">&nbsp;Enable</label>&nbsp;&nbsp;
                        <input class="" type="radio" name="lengthOfService" id="lengthOfServicefalse" value="false"
                          (click)="lengthOfService($event)" checked />
                        <label class="form-check-label" for="lengthOfService"
                          class="walletConfigModel">&nbsp;Disable</label>
                      </span>
                    </h6>
                    <table class="table table-striped table-bordered" *ngIf="lengthofServiceCheck" style="width: 80%">
                      <thead>
                        <tr>
                          <th width="5%"></th>
                          <!-- <th width="10%">S.no</th> -->
                          <th width="25%">Tier Name</th>
                          <th width="15%">From</th>
                          <th width="15%">To</th>
                          <th width="15%"></th>
                          <th width="20%" *ngIf="showemptywalletConfig">
                            Wallet Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="
                            let dynamic of dynamicArrayService;
                            let i = index
                          ">
                          <td>
                            <button class="fa fa-trash-o deletetier"
                              (click)="deleteRowServiceBlock3(i, dynamic)"></button>
                          </td>
                          <!-- <td>
                                <input  style="text-align: center;"  class="form-control1" name="{{dynamic.sno}}" [(ngModel)]="dynamic.sno" [ngModelOptions]="{standalone: true}" (keypress)="numberOnly($event)"  type="text" />
                              </td> -->
                          <td>
                            <input class="form-control1" name="{{ dynamic.tierName }}" [(ngModel)]="dynamic.tierName"
                              [ngModelOptions]="{ standalone: true }" type="text" placeholder="Enter Tier Name" />
                          </td>
                          <td>
                            <input class="form-control1" name="{{ dynamic.from }}" [(ngModel)]="dynamic.from"
                              [ngModelOptions]="{ standalone: true }" (keypress)="numberOnly($event)" type="text"
                              placeholder="" />
                          </td>
                          <td>
                            <input class="form-control1" name="{{ dynamic.to }}" [(ngModel)]="dynamic.to"
                              [ngModelOptions]="{ standalone: true }" (keypress)="numberOnly($event)" type="text"
                              placeholder="" />
                          </td>
                          <td>
                            <select class="form-control1" id="lengthofService" name="{{ dynamic.period }}"
                              [(ngModel)]="dynamic.period" [ngModelOptions]="{ standalone: true }">
                              <option [value]="null" disabled>Select</option>
                              <option value="years">Years</option>
                              <option value="months">Months</option>
                            </select>
                          </td>
                          <td *ngIf="showemptywalletConfig">
                            <input class="form-control1 TierAmount" name="{{ dynamic.walletAmount }}"
                              [(ngModel)]="dynamic.walletAmount" [ngModelOptions]="{ standalone: true }" type="text" />
                          </td>
                        </tr>
                        <tr>
                          <!-- <td>
                                <button class="fa fa-plus " (click)="addRow()">Add</button>
                              </td> -->
                        </tr>
                      </tbody>
                    </table>

                    <div *ngIf="showemptywalletConfig">
                      <h6 class="tiertable">
                        % of Annual income & Wallet Setup&nbsp;&nbsp;<button class="addtierbutton"
                          (click)="addRowAnnual()" *ngIf="annualincomeCheck">
                          <strong>+&nbsp;Add</strong>
                        </button>

                        <span class="enabledtierplans">
                          <input class="" type="radio" name="annualIncome" id="annualIncometrue" value="true"
                            (click)="annualIncome($event)" />
                          <label class="form-check-label" for="workinghoursno"
                            class="walletConfigModel">&nbsp;Enable</label>&nbsp;&nbsp;
                          <input class="" type="radio" name="annualIncome" id="annualIncomefalse" value="false"
                            (click)="annualIncome($event)" checked />
                          <label class="form-check-label" for="workinghoursno"
                            class="walletConfigModel">&nbsp;Disable</label>
                        </span>
                      </h6>
                      <table class="table table-striped table-bordered" *ngIf="annualincomeCheck" style="width: 80%">
                        <thead>
                          <tr>
                            <th width="5%"></th>
                            <!-- <th width="10%">S.no</th> -->
                            <th width="25%">Tier Name</th>
                            <th width="15%">%</th>
                            <th width="15%">From</th>
                            <th width="15%">To</th>
                            <th width="20%" *ngIf="showemptywalletConfig">
                              Wallet Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="
                              let dynamic of dynamicArrayAnnualIncome;
                              let i = index
                            ">
                            <td>
                              <button class="fa fa-trash-o deletetier"
                                (click)="deleteRowAnnualBlock3(i, dynamic)"></button>
                            </td>
                            <!-- <td>
                                  <input  style="text-align: center;"  class="form-control1" name="{{dynamic.sno}}" [(ngModel)]="dynamic.sno" [ngModelOptions]="{standalone: true}" (keypress)="numberOnly($event)"  type="text" />
                                </td> -->
                            <td>
                              <input class="form-control1" name="{{ dynamic.tierName }}" [(ngModel)]="dynamic.tierName"
                                [ngModelOptions]="{ standalone: true }" type="text" placeholder="Enter Tier Name" />
                            </td>
                            <td>
                              <input class="form-control1" name="{{ dynamic.percentage }}"
                                [(ngModel)]="dynamic.percentage" [ngModelOptions]="{ standalone: true }" type="text"
                                placeholder="" />
                            </td>

                            <td>
                              <input class="form-control1" name="{{ dynamic.from }}" [(ngModel)]="dynamic.from"
                                [ngModelOptions]="{ standalone: true }" type="text" placeholder="" />
                            </td>
                            <td>
                              <input class="form-control1" name="{{ dynamic.to }}" [(ngModel)]="dynamic.to"
                                [ngModelOptions]="{ standalone: true }" type="text" placeholder="" />
                            </td>
                            <td *ngIf="showemptywalletConfig">
                              <input class="form-control1 TierAmount" name="{{ dynamic.walletAmount }}"
                                [(ngModel)]="dynamic.walletAmount" [ngModelOptions]="{ standalone: true }"
                                type="text" />
                            </td>
                            <td style="display: none">
                              <input type="hidden" class="form-control1" name="{{ dynamic.annualIncome }}"
                                [(ngModel)]="dynamic.annualIncome" [ngModelOptions]="{ standalone: true }" type="number"
                                placeholder="" />
                            </td>
                          </tr>
                          <tr>
                            <!-- <td>
                                  <button class="fa fa-plus " (click)="addRow()">Add</button>
                                </td> -->
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div style="margin-top: 10px">
                      <!-- <button type="button" class="btn btn-danger tierClose">Close</button> -->
                      <button type="button" class="btn btn-primary tierSave" (click)="submitTierInfo()">
                        Save
                      </button>

                      <button type="button" style="margin-right: 5px" class="btn btn closemodel"
                        data-bs-dismiss="modal">
                        Close</button>&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="carousel-item">
              <form class="tierwalletInfo12">
                <div class="row">
                  <div class="form-group col-12">
                    <h6 class="configtiertable">
                      Configure Tiers, Assign Selected Plans to
                      Tiers&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
                    </h6>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-12" style="overflow: scroll; height: 450px" *ngIf="showtieradvplans">
                    <div *ngFor="
                        let item of selectedPackagePlansInfoTierBlock3
                          | keyvalue
                      ">
                      <!-- *ngIf="item.value.length>0" -->

                      <div class="row plansscreen">
                        <div class="form-row">
                          <!-- <h6 class="tiergroupname">{{selectedPackagePlansInfoTiername[item.key]}}</h6> -->

                          <h6 class="tiergroupname" *ngIf="item.value.length > 0">
                            {{ item.key }}
                          </h6>
                        </div>
                        <div class="form-group packageadv" *ngFor="let planLevel of item.value">
                          <div class="row">
                            <div class="col-3">
                              <div class="tierplanselection" [style.background-color]="
                                  planLevel.backgroundColor
                                    ? planLevel.backgroundColor
                                    : defaultColor
                                ">
                                {{ planLevel.subGroupName }}
                              </div>
                            </div>

                            <div class="col-4">
                              <ng-multiselect-dropdown *ngIf="showinputBlock3" [placeholder]="'Select'"
                                [closeOnSelect]="true" name="tierselection" [settings]="dropdownSettings" [data]="
                                  selectedPackagesavailableTiers3Block3[
                                    planLevel.packageId
                                  ][planLevel.subGroupid] || configureTierList
                                " [(ngModel)]="
                                  selectedPackagesassignedTiers3Block3[
                                    planLevel.packageId
                                  ][planLevel.subGroupid]
                                " (onSelect)="
                                  onItemSelectTiersBlock3(
                                    $event,
                                    planLevel,
                                    planLevel
                                  )
                                " (onDeSelect)="
                                  onItemremoveTiersBlock3($event, planLevel)
                                ">
                              </ng-multiselect-dropdown>

                              <ng-multiselect-dropdown *ngIf="showinput1Block3" [placeholder]="'Select'"
                                [closeOnSelect]="true" name="tierselection" [settings]="dropdownSettings" [data]="
                                  selectedPackagesavailableTiers3Block3[
                                    planLevel.packageId
                                  ][planLevel.subGroupid] || configureTierList
                                " [(ngModel)]="
                                  selectedPackagesassignedTiers3Block3[
                                    planLevel.packageId
                                  ][planLevel.subGroupid]
                                " (onSelect)="
                                  onItemSelectTiersBlock3($event, planLevel)
                                " (onDeSelect)="
                                  onItemremoveTiersBlock3($event, planLevel)
                                ">
                              </ng-multiselect-dropdown>
                            </div>
                            <div class="col-5"></div>

                            <!-- <div class="flex-item tierslection">
                          </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <div class="modal-footer">
                <button type="button" class="btn btn closemodel" data-bs-dismiss="modal">
                  Close
                </button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                  (click)="showSlectedPlansTiersBlock3()">
                  Save
                </button>

                <!-- </div> -->
              </div>
            </div>
          </div>
          <span class="carousel-control-prev-icon carousel-control-prev" aria-hidden="true"
            data-bs-target="#carouselExampleFadeBlock3" data-bs-slide="prev"></span>

          <span class="carousel-control-next-icon carousel-control-next" #nextpage aria-hidden="true"
            data-bs-target="#carouselExampleFadeBlock3" data-bs-slide="next"></span>

          <!-- </button> -->
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="groupAmdins-modal" data-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">Please Add at least One Group Contact</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="adminform" (ngSubmit)="addGroupadmin()">
          <div class="input-wrapper row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">First Name<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="adminfirstname" placeholder="First Name"
                (keypress)="alphabatesOnly($event)" formControlName="adminfirstname" />

              <div *ngIf="
                  f['adminfirstname'].touched && f['adminfirstname'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    f['adminfirstname'].errors &&
                    f['adminfirstname'].errors['required']
                  ">
                  Please enter first name
                </div>
                <div *ngIf="
                    f['adminfirstname'].errors &&
                    f['adminfirstname'].errors['minlength']
                  ">
                  First name should be 3 characters
                </div>
                <div *ngIf="
                    f['adminfirstname'].errors &&
                    f['adminfirstname'].errors['maxlength']
                  ">
                  First name must not exceed 20 characters
                </div>
                <div *ngIf="
                    f['adminfirstname'].errors &&
                    f['adminfirstname'].errors['pattern']
                  ">
                  First name Shouldn't allow numbers, special characters and
                  blank spaces
                </div>
              </div>
              <!-- <div *ngIf="submittedadmin && f['adminfirstname'].errors" class="invalid-feedback">
                      <div *ngIf="f['adminfirstname'].errors['required']">First Name is required</div>
                      <div *ngIf="f['adminfirstname'].errors['minlength']">
                        First Name must be at least 3 characters
                      </div>
                      <div *ngIf="f['adminfirstname'].errors['maxlength']">
                        First Name must not exceed 20 characters
                      </div>
                    </div> -->
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">Last Name<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="adminlastname"
                (keypress)="alphabatesOnly($event)" placeholder="Last Name" formControlName="adminlastname" />

              <div *ngIf="f['adminlastname'].touched && f['adminlastname'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['adminlastname'].errors &&
                    f['adminlastname'].errors['required']
                  ">
                  Please enter Last name
                </div>
                <div *ngIf="
                    f['adminlastname'].errors &&
                    f['adminlastname'].errors['minlength']
                  ">
                  Last name should be 3 characters
                </div>
                <div *ngIf="
                    f['adminlastname'].errors &&
                    f['adminlastname'].errors['maxlength']
                  ">
                  Last name must not exceed 20 characters
                </div>
                <div *ngIf="
                    f['adminlastname'].errors &&
                    f['adminlastname'].errors['pattern']
                  ">
                  Last name Shouldn't allow numbers, special characters and
                  blank spaces
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">Phone Number<span style="color: red">*</span></label>

              <input type="tel" class="form-control checking-field" id="adminphone" placeholder="Phone"
                (keypress)="numberOnly($event)" (change)="phoneFormat($event)" formControlName="adminphone" />

              <div *ngIf="f['adminphone'].touched && f['adminphone'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['adminphone'].errors && f['adminphone'].errors['required']
                  ">
                  Please enter phone number
                </div>
                <div *ngIf="
                    f['adminphone'].errors &&
                    f['adminphone'].errors['minlength']
                  ">
                  Phone number minimum of 10 digits
                </div>
                <div *ngIf="
                    f['adminphone'].errors &&
                    f['adminphone'].errors['maxlength']
                  ">
                  Phone number maximum of 10 digits
                </div>
                <!-- <div *ngIf="f['adminphone'].errors && f['adminphone'].errors['maxlength']">Phone number must not exceed 20 digits</div> -->
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">Email<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="email" placeholder="Email"
                formControlName="adminemail" (input)="textChangeToLowerCase(f, 'adminemail')" />
              <div *ngIf="f['adminemail'].touched && f['adminemail'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['adminemail'].errors && f['adminemail'].errors['required']
                  ">
                  Please enter email
                </div>
                <div *ngIf="
                    f['adminemail'].errors && f['adminemail'].errors['pattern']
                  ">
                  Please enter valid email
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">Role<span style="color: red">*</span></label>

              <select (change)="othersField($event)" class="form-control" id="lengthofService" formControlName="role"
                [(ngModel)]="selectedOption">
                <option [value]="null" disabled>Select</option>
                <!-- <option value="CORPORATE_ADMIN">Admin</option> -->
                <option value="CORPORATE_ACCOUNTANT">Accountant</option>
                <option value="CORPORATE_EXECUTIVE">Executive</option>
                <option value="CORPORATE_PLAN_ADMINISTRATOR">
                  Plan Administrator
                </option>
                <option value="CORPORATE_ADMIN">System Administrator</option>

                <option value="CORPORATE_WELLNESS_CHAMPION">
                  Wellness Champion
                </option>
                <option value="CORPORATE_OTHERS">Others</option>
                <!-- <option value="CORPORATE_OTHERS">Other</option> -->
              </select>

              <div *ngIf="f['role'].touched && f['role'].invalid" class="help-block text-danger">
                <div *ngIf="f['role'].errors && f['role'].errors['required']">
                  Please select role
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6" *ngIf="showOtherField">
              <div class="form-group">
                <label for="Corporation" class="Corporation">Other<span style="color: red">*</span></label>
                <input type="text" class="form-control checking-field" id="roleName" formControlName="roleName" />
                <div *ngIf="f['roleName'].touched && f['roleName'].invalid" class="help-block text-danger">
                  <div *ngIf="
                      f['roleName'].errors && f['role'].hasError('required')
                    ">
                    Please enter other role
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          Close
        </button>
        <button type="button" class="btn btn-primary" [disabled]="adminform.invalid" (click)="addGroupadmin()">
          Save
        </button>
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>

<div class="modal fade" id="bulkupload-modal" data-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">Are you sure want to add?</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" tooltip="List will be replaced overwriting existing."
          id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          {{lang.No}}
        </button>
        <button type="button" class="btn btn-primary" tooltip="List will be appended with new only."
          data-bs-dismiss="modal" #closemodel (click)="addGroupadmin()">
          {{lang.Yes}}
        </button>
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>

<div class="modal fade" id="showBulkEmployeelist" data-backdrop="static" tabindex="-1" data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Employee_List}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeBulkPlan()"></button>
      </div>
      <div class="modal-body" style="overflow-y:auto; max-height: 70vh;">
        <table datatable [dtOptions]="dtOptions" id="bulkdattable" [dtTrigger]="dtTrigger">
          <!-- <th>S.no</th> -->
          <th>{{lang.First_Name}}</th>
          <th>{{lang.Last_Name}}</th>
          <th>{{lang.Email}}</th>
          <th *ngIf="!disableActionsForRoster">{{lang.Actions}}</th>
          <tr *ngFor="let item of filteredEmployeeList;let i=index">
            <ng-container *ngIf="item.bulkPlanLevelId==selectedSubGrpId;else nodata;">
              <!-- <td>{{i+1}}</td> -->
              <td>{{item.firstName}}</td>
              <td>{{item.lastName}}</td>
              <!-- <td [title]="
              item.email.length > 24
              ? item.email
              : ''
              ">{{
                item.email.length > 24
                ? item.email.slice(0, 6) +
                "..." +
                item.email.slice(-6)
                : item.email
                }}</td> -->
              <td *ngIf="item.email">{{
                item.email.length > 24
                ? item.email.slice(0, 6) +
                "..." +
                item.email.slice(-6)
                : item.email
                }}</td>
              <td style="display:flex" *ngIf="!disableActionsForRoster">
                <!-- <a class="btn btn-default editpencil" title="Edit" data-toggle="tooltip"
                  (click)="editemployeeexcel(item,i,selectedSubGrpId)"><i class="bi bi-pencil-fill"></i></a>&nbsp;&nbsp; -->
                <a class="btn btn-default deleteicon" title="Delete" data-toggle="tooltip"
                  (click)="deleteemployeeexcel(item,i,selectedSubGrpId)"><i class="bi bi-trash-fill"></i></a>
              </td>

            </ng-container>
            <ng-template #nodata>
              <p>No Data Available</p>
            </ng-template>

          </tr>
        </table>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" tooltip="List will be replaced overwriting existing."
          id="closeaddadmin" data-bs-dismiss="modal" #closemodel (click)="closeBulkPlan()">
          {{lang.Close}}
        </button>

      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>

<div class="modal fade" id="edit-headcount" data-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title w-100 text-center">Edit Head Count</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        
        <div class="packageWrapper block3packagewrapper plansscreenbulk" *ngFor="let package of balkPlans; let i = index">
          <div class="form-group package" style="margin-top:-2px">
            <div class="package-groups1" *ngFor="let group of package?.groups; let j = index" title="">
              <div class="planbody" *ngIf="
                group && group.subGroups && group.subGroups.length > 0
              ">
                <div *ngFor="let subgroup of group.subGroups; let k = index">
                  <div *ngIf="subgroup" id="collapsethreeBulk{{
                      package?.groups?.length >  1
                        ? subgroup.parentId
                        : package?.id
                    }}" class="accordion-collapse collapse show">
                    <div>
                      <div id="checkbox-{{subgroup.id}}" *ngIf="checkboxCheck[subgroup.id]==true && editPlanHeadCount.planLevelId == subgroup.id" class="countblock">
  
                        <table class="border-0">
                          <tbody>

                            <!-- current head count -->
                            <tr class="bg-transparent">
                              <td>
                                <label for="Corporation" class="Corporation">Current Head Count</label>
                              </td>
                              <td>
                                <input type="number" class="headcountbox" [(ngModel)]="currentHeadCount"
                                  class="headerCount" (keypress)="preventNegative($event)" (input)="preventNonNumeric($event)"
                                  (change)="updateBulkHeadCountTotal($event,subgroup,subgroup.settings?.requiredCustomersCount)" disabled>&nbsp;
                                &nbsp;
                                <span class="text-left"
                                  *ngIf="checkboxCheck[subgroup.id] && showinputboxvalue[subgroup.id] && (showHeadCount[subgroup.id] || showHeadCount[subgroup.id] >0)">
                                  <i class="fa fa-eye" title="view" aria-hidden="true" data-bs-toggle="modal"
                                    (click)="editEmployees(subgroup.id,'view','show')"></i>
                                </span>
                              </td>
                            </tr>

                            <!-- new head count -->
                            <tr class="bg-transparent">
                              <td>
                                <label for="Corporation" class="Corporation">New Head Count</label>
                              </td>
                              <td>
                                <input type="number" class="headcountbox" [(ngModel)]="newHeadCount"
                                  class="headerCount" (keypress)="preventNegative($event)" (input)="preventNonNumeric($event)"
                                  (change)="updateBulkHeadCountTotal($event,subgroup,subgroup.settings?.requiredCustomersCount)">&nbsp;
                                <label for="Corporation" class="Corporation"
                                  *ngIf="!newHeadCount || newHeadCount <=0" style="color:red">
                                  {{lang.Please_enter_head_count_for}} {{subgroup?.name}}</label>
                                &nbsp;
          
                                <span class="text-left"
                                  *ngIf="checkboxCheck[subgroup.id] && showinputboxvalue[subgroup.id] && (showHeadCount[subgroup.id] || showHeadCount[subgroup.id] >0)">
                                  <label for="DownloadButton" id="uploadButtonExcel" title="Download Template" data-taggle="tooltip"
                                    (click)="exportAsXLSX(subgroup.id,subgroup.settings.memberDetailsKeysDB)" class="Cursorpointer">
                                    <img src="../../../assets/img/download-template.png" style="width:100px;height:30px">
                                  </label>&nbsp;
                                  <label for="uploadButton-{{subgroup.id}}" id="uploadButtonExcel-{{subgroup.id}}"
                                    title="Upload Employee/Entity List" data-taggle="tooltip" class="Cursorpointer">
                                    <img src="../../../assets/img/upload-employee-list.png" style="width:100px;height:30px">
                                    <input id="uploadButton-{{subgroup.id}}" #myFileInput style="display: none" type="file"
                                      (input)="onFileChangeExcel($event,subgroup.id,subgroup.settings.memberDetailsKeysDB)" />
                                  </label> &nbsp;
                                  <i class="fa fa-eye" title="view" aria-hidden="true" data-bs-toggle="modal"
                                    (click)="editEmployees(subgroup.id,'edit','show')"></i>
                                </span>
                              </td>
                            </tr>

                            <!-- effective date -->
                            <tr class="bg-transparent">
                              <td>
                                <label>Effective Date</label>
                              </td>
                              <td>
                                <select class="form-control1" style="width:auto; font-size: 14px;" id="lengthofService" [(ngModel)]="effectiveDate" (change)="toggleExpandActivePlanExpiry('date')">
                                  <option [value]="null" disabled>Select</option>
                                  <option *ngFor="let date of dateOptions" [value]="date.value">{{ date.text }}</option>
                                </select>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div *ngIf="nonEditingBulkPlan" class="d-flex">
                          <input 
                            type="checkbox"
                            (change)="toggleExpandActivePlanExpiry()"
                            id="expandActivePlanExpiry"
                          />&nbsp;
                          <label 
                            for="expandActivePlanExpiry" 
                            class="mx-2"
                          >Expand termination date of active plan to activation date of provisioning plan</label>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
  
              </div>
  
            </div>
          </div>
  
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" tooltip="Close"
          id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary saveAndNext" tooltip="Save"
          data-bs-dismiss="modal" style="background:rgb(56, 76, 159) !important;color:white !important;" 
          (click)="saveHeadCount()" [disabled]="effectiveDate==null">
          {{lang.Save}}
        </button>

      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>


<div class="modal fade" id="terminate-bulkplan" data-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title w-100 text-center">Terminate {{editPlanHeadCount.planLevel}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        
        <div class="row">
          <div class="col-12 mb-3">
            Choose termination date to expire {{editPlanHeadCount.planLevel}} plan of headcount {{editPlanHeadCount.quantity}}
          </div>
          
          <div class="col-4 mb-3">
            <label>Effective Date</label>
          </div>
          <div class="col-8 mb-3">
            <select class="form-control1" style="width:auto; font-size: 14px;" id="lengthofService" [(ngModel)]="effectiveDate" (change)="toggleTerminationExpiryDate()">
              <option [value]="null" disabled>Select</option>
              <option *ngFor="let date of dateOptions" [value]="date.value">{{ date.text }}</option>
            </select>
          </div>

          <div *ngIf="editPlanHeadCount.status=='Provisioning' && nonEditingBulkPlan && showActivateOldPlan">
            <input 
            type="checkbox" 
            [checked]="activateOldPlan" 
            (click)="toggleActivateOldPlan()"
            id="activateOldPlan"
            />&nbsp;
            <label 
              for="activateOldPlan" 
              class="mx-2"
            >Remove termination date for active plan?</label>
          </div>
          <div *ngIf="editPlanHeadCount.status=='Active' && nonEditingBulkPlan">
            <input 
              type="checkbox" 
              [checked]="updateProvisioningDate" 
              (click)="toggleUpdateProvisioningDate()"
              id="updateProvisioningDate"
            />&nbsp;
            <label 
              for="updateProvisioningDate" 
              class="mx-2"
            >Activate Provisioning Plan to the effective date</label>
          </div>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" tooltip="Close"
          id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary saveAndNext" tooltip="Save"
          data-bs-dismiss="modal" style="background:rgb(56, 76, 159) !important;color:white !important;"
          (click)="submitExpiration()" [disabled]="effectiveDate==null">
          {{lang.Save}}
        </button>

      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>